(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-add-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-add');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-add');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);

  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop;
    }

    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-query-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-query');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-query');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);

  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop;
    }

    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balcony"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('balcony-next');
      const events = Array.prototype.slice.apply(document.getElementById('balcony-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected'); 
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bathroom"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('bathroom-next');
      const events = Array.prototype.slice.apply(document.getElementById('bathroom-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');  
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-26-summary-pd-spin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-26-summary-pd-spin';
    const ROOT_SELECTOR = '[data-ndev-26-summary-pd-spin]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const listeners = [];

      function on(el, type, handler) {
        if (!el) return;
        el.addEventListener(type, handler);
        listeners.push({ el: el, type: type, handler: handler });
      }

      const trigger = root.querySelector('.ndev-26-summary-pd-spin__trigger');
      on(trigger, 'click', function (e) {
        e.preventDefault();
        const spinTrigger = document.getElementById('crazyrocket-launch-icon');
        if (spinTrigger) {
          spinTrigger.click();
        } else if (CrazyRocket?.showPopUp && typeof CrazyRocket.showPopUp === 'function') {
          CrazyRocket.showPopUp({ forceShow: true })
        }
      });

      controllers.set(root, {
        root: root,
        destroy: function () {
          listeners.forEach(function (item) {
            item.el.removeEventListener(item.type, item.handler);
          });
          listeners.length = 0;
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-ax26-coverage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-ax26-coverage';
    const ROOT_SELECTOR = '[data-ndev-ax26-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function clamp01(n) {
      if (n <= 0) return 0;
      if (n >= 1) return 1;
      return n;
    }

    function parseNumber(v, fallback) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const masks = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-ax26-coverage-mask]'));
      const stickyEl = root.querySelector('.ndev-ax26-coverage');
      let rafId = 0;
      let destroyed = false;
      let lastProgress = -1;
      let lastTextProgress = -1;

      // 从 wrapper 的 CSS 变量读取行程
      const travelDistanceVh = parseNumber(getComputedStyle(root).getPropertyValue('--wrapper-height'), 300) - 100;
      const textTravelShare = Math.min(
        1,
        Math.max(0.08, parseNumber(getComputedStyle(root).getPropertyValue('--coverage-text-travel-ratio'), 0.32))
      );

      function update() {
        rafId = 0;
        if (destroyed) return;

        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rect = root.getBoundingClientRect();
        const wrapperTopPx = rect.top + scrollTop;

        const travelPx = (travelDistanceVh / 100) * vh;
        const scrollDistance = scrollTop - wrapperTopPx;
        const progress = 1 - clamp01(scrollDistance / travelPx);

        const textTravelPx = travelPx * textTravelShare;
        const textProgress = 1 - clamp01(scrollDistance / textTravelPx);

        // 变化检测：值未变时跳过 DOM 写入，减少 style recalc
        if (Math.abs(textProgress - lastTextProgress) >= 0.001) {
          lastTextProgress = textProgress;
          stickyEl.style.setProperty('--coverage-text-scroll-progress', String(textProgress));
        }
        if (Math.abs(progress - lastProgress) >= 0.001) {
          lastProgress = progress;
          for (let i = 0; i < masks.length; i++) {
            const mask = masks[i];
            if (!mask) continue;
            mask.style.setProperty('--mask-opacity', progress);
          }
        }
      }

      function scheduleUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(update);
      }

      function onScroll() {
        scheduleUpdate();
      }

      function onResize() {
        scheduleUpdate();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      scheduleUpdate();

      controllers.set(root, {
        root: root,
        destroy: function () {
          destroyed = true;
          stickyEl.style.removeProperty('--coverage-text-scroll-progress');
          try { window.removeEventListener('scroll', onScroll); } catch (e) {}
          try { window.removeEventListener('resize', onResize); } catch (e) {}
          try { if (rafId) window.cancelAnimationFrame(rafId); } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-cart-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const ROOT_SELECTOR = '.ndev-cart-content[data-ndev-cart-content]';
    const controllers = window.ndevCartContentControllers || (window.ndevCartContentControllers = new WeakMap());

    function getNarwal() {
      return (typeof $narwal !== 'undefined') ? $narwal : null;
    }

    function getRoutesRoot() {
      if (window.$narwalCart && typeof window.$narwalCart.routesRoot === 'function') return window.$narwalCart.routesRoot();
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function getCartPath() {
      const root = getRoutesRoot();
      return root + (root.endsWith('/') ? 'cart' : '/cart');
    }

    /** 从 root.dataset 读取多语言文案 / 埋点事件名等配置。 */
    function getText(root, key, fallback) {
      const v = root && root.dataset ? root.dataset[key] : '';
      return (v && String(v).trim()) ? String(v).trim() : (fallback || '');
    }

    let overlayUnlock = null;
    function lockPage() {
      if (window.$ndevOverlay && typeof window.$ndevOverlay.lock === 'function') {
        overlayUnlock = window.$ndevOverlay.lock({ source: 'ndev-cart-content', ariaLabel: 'Loading' });
      }
    }

    function unlockPage() {
      if (typeof overlayUnlock === 'function') {
        try { overlayUnlock(); } catch (e) {}
      }
      overlayUnlock = null;
    }

    function announce(root, message) {
      if (!root) return;
      const el = root.querySelector('[data-cart-a11y-status]');
      if (!el) return;
      const msg = String(message || '').trim();
      if (!msg) return;
      el.textContent = '';
      // 让读屏更稳定地感知变化
      setTimeout(function () {
        el.textContent = msg;
      }, 10);
    }

    function tryReport(root, datasetKey, params) {
      const eventName = getText(root, datasetKey, '');
      if (!eventName) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.report !== 'function') return;
      narwal.report({
        event: eventName,
        params: Object.assign({ page: 'self', module: 'cart' }, params || {})
      });
    }

    function getProductNameFromRow(row) {
      const nameEl = row && row.querySelector ? row.querySelector('.ndev-cart-content__name') : null;
      const txt = nameEl ? nameEl.textContent : '';
      return txt ? txt.trim() : '';
    }

    function showErrorPopup(root, message) {
      const msg = String(message || '').trim() || getText(root, 'textError', 'Something went wrong, please try later.');
      announce(root, msg);

      const narwal = getNarwal();
      if (!narwal || typeof narwal.popup !== 'function') return;

      const popupId = 'ndev-cart-popup-' + String(Date.now()) + '-' + String(Math.floor(Math.random() * 10000));
      const closeText = getText(root, 'textClose', 'Close');
      const escapeHtml = function (str) {
        return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      const html = `
<div class="m-popup" data-ndev-cart-popup="${popupId}">
  <div class="popup-view flex-center">
    <div class="ndev-cart-popup" style="width:min(520px, 92vw); background:#fff; border-radius:12px; padding:24px; box-shadow:0 12px 40px rgba(0,0,0,.18); position:relative;">
      <button type="button" class="close flex-center" node-name="popup_close" aria-label="${escapeHtml(closeText)}" style="position:absolute; top:12px; right:12px; width:36px; height:36px; border:none; background:rgba(0,0,0,.06); border-radius:999px; cursor:pointer;">
        <span aria-hidden="true" style="font-size:22px; line-height:1;">×</span>
      </button>
      <div style="display:flex; flex-direction:column; gap:10px;">
        <div style="font-size:14px; line-height:1.45; color:rgba(1,1,1,.8); word-break:break-word;">${escapeHtml(msg)}</div>
      </div>
    </div>
  </div>
</div>
      `.trim();

      const ins = narwal.popup({
        html: html,
        onClose: function () {
          const node = document.querySelector('[data-ndev-cart-popup="' + popupId + '"]');
          if (node && node.parentElement) node.parentElement.remove();
        }
      });

      if (ins && ins.onShow) {
        try { ins.onShow(); } catch (e) {}
      }
    }

    /**
     * 刷新单个 cart-content root：
     * - 请求 `/cart?view=cart-content`
     * - 用返回的 `.ndev-cart-content__container` 覆盖当前 container
     *
     * 说明：
     * - view 模板可能只返回 container；因此解析时同时兼容「container 直出」与「整段 section 直出」
     */
    async function refreshSection(root) {
      const container = root.querySelector('.ndev-cart-content__container');
      if (!container) return;

      const url = getCartPath() + '?view=' + encodeURIComponent('cart-content');
      const res = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      });
      if (!res.ok) throw new Error('Failed to refresh cart section');
      const html = await res.text();
      if (!html || !String(html).trim()) return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      // view 模板可能只返回 container，本地 section 刷新则只需要拿到 container 即可
      const nextContainer =
        tmp.querySelector('.ndev-cart-content__container') ||
        (tmp.querySelector(ROOT_SELECTOR) ? tmp.querySelector(ROOT_SELECTOR).querySelector('.ndev-cart-content__container') : null);
      if (!nextContainer) return;

      container.innerHTML = nextContainer.innerHTML;
    }

    let externalRefreshInFlight = null;
    let externalRefreshQueued = false;

    /**
     * 由外部事件触发的刷新（例如推荐区/其他模块 add/remove 之后 emit `cart:change`）
     * - 合并短时间多次触发，避免重复请求
     * - 同时刷新页面上所有 cart-content roots（弱 Map 控制器支持多实例）
     */
    function refreshAllRootsByExternalEvent(detail) {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      if (!roots || !roots.length) return Promise.resolve();

      // 合并短时间的多次触发，避免 UI 抖动 / 重复请求
      if (externalRefreshInFlight) {
        externalRefreshQueued = true;
        return externalRefreshInFlight;
      }

      externalRefreshInFlight = (async function () {
        lockPage();
        for (var i = 0; i < roots.length; i++) {
          roots[i].classList.add('ndev-cart-content--loading');
          roots[i].setAttribute('aria-busy', 'true');
        }

        let firstErr = null;
        await Promise.all(Array.prototype.map.call(roots, function (root) {
          return refreshSection(root).catch(function (err) {
            firstErr = firstErr || err;
          });
        }));

        if (firstErr) {
          // 错误提示复用现有弹窗（只提示一次）
          showErrorPopup(roots[0], (firstErr && firstErr.message) ? String(firstErr.message) : '');
        } else {
          // 可选：给读屏一个更明确的提示（避免空 detail 时乱报）
          if (detail && detail.action === 'add') announce(roots[0], 'Cart updated.');
        }
      })().finally(function () {
        const roots2 = document.querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots2.length; i++) {
          roots2[i].classList.remove('ndev-cart-content--loading');
          roots2[i].removeAttribute('aria-busy');
        }
        unlockPage();

        externalRefreshInFlight = null;
        if (externalRefreshQueued) {
          externalRefreshQueued = false;
          // 再跑一次（吸收期间的变化）
          refreshAllRootsByExternalEvent(detail);
        }
      });

      return externalRefreshInFlight;
    }

    function bindExternalCartChange() {
      if (window.ndevCartContentExternalCartChangeBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentExternalCartChangeBinded = true;
      narwal.bind('cart:change', function (payload) {
        // 避免自己 emit 的 cart:change 导致本模块二次刷新
        if (payload && payload.source === 'ndev-cart-content') return;
        refreshAllRootsByExternalEvent(payload || null).catch(function () {});
      });
    }

    function bindCheckout() {
      if (window.ndevCartContentCheckoutBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentCheckoutBinded = true;
      narwal.bind('cart:checkout', function (payload) {
        // 允许外部传入自定义跳转链接（兼容特殊结账流程）
        const url = payload && payload.url ? String(payload.url) : '';
        if (url) {
          window.location.href = url;
          return;
        }

        const root = getRoutesRoot();
        window.location.href = root + (root.endsWith('/') ? 'checkout' : '/checkout');
      });
    }

    /**
     * 广播 cart 变化：
     * - source 用于避免本模块收到自己发出的事件后再次刷新（见 bindExternalCartChange）
     */
    function emitCartChange(detail) {
      const narwal = getNarwal();
      if (!narwal || typeof narwal.emit !== 'function') return;
      narwal.emit('cart:change', Object.assign({ source: 'ndev-cart-content', ts: Date.now() }, detail || {}));
    }

    /**
     * 修改指定 line 的数量（quantity=0 表示删除）
     *
     * 流程：
     * - lock overlay（全局引用计数）
     * - 调用 `$narwalCart.setLineQuantity` 更新 cart
     * - 刷新本 section（HTML partial replace）
     * - emit `cart:change` 通知其它模块（推荐区等）
     */
    async function changeLine(root, line, quantity, meta) {
      if (!window.$narwalCart || typeof window.$narwalCart.setLineQuantity !== 'function') return;

      const beforeLineCount = root ? root.querySelectorAll('[data-cart-line]').length : 0;
      root.classList.add('ndev-cart-content--loading');
      root.setAttribute('aria-busy', 'true');
      lockPage();

      try {
        const cart = await window.$narwalCart.setLineQuantity({ line: line, quantity: quantity });

        const count = window.$narwalCart.countItems ? window.$narwalCart.countItems(cart) : (cart && cart.item_count) || 0;
        if (window.$narwalCart.updateHeaderCartCount) window.$narwalCart.updateHeaderCartCount(count);

        if (quantity === 0 && beforeLineCount === 1) {
          window.location.href = getRoutesRoot() + 'cart';
        } else {
          await refreshSection(root);
        }

        // ✅ 广播删除/改数量事件：推荐区等其它模块可监听并自行刷新
        const action = (quantity === 0) ? 'remove' : 'update';
        emitCartChange({
          action: action,
          line: line,
          quantity: quantity,
          btn: meta && meta.btn ? meta.btn : undefined,
          cart: cart
        });
      } catch (err) {
        const msg = (err && err.message) ? String(err.message) : getText(root, 'textError', '');
        const isLimit = quantity > 0 && err && (err.status === 422);

        if (isLimit) {
          tryReport(root, 'eventQtyLimit', {
            btn: 'qty_limit',
            action: meta && meta.action ? meta.action : undefined,
            quantity: quantity
          });
        } else {
          tryReport(root, 'eventRequestError', {
            btn: (meta && meta.btn) ? meta.btn : 'request_error',
            action: meta && meta.action ? meta.action : undefined,
            quantity: quantity
          });
        }

        showErrorPopup(root, msg);

        // 尝试回滚 UI 到最新 cart 状态（避免数量选择器与真实数据不一致）
        await refreshSection(root).catch(function () {});
      } finally {
        unlockPage();
        root.classList.remove('ndev-cart-content--loading');
        root.removeAttribute('aria-busy');
      }
    }

    function initOne(root) {
      if (!root) return;
      if (root.getAttribute('data-ndev-cart-initialized') === '1') return;
      root.setAttribute('data-ndev-cart-initialized', '1');

      function onClick(e) {
        // 结账按钮兜底：
        // - cart-content 刷新使用 innerHTML 替换，snippets/ndev-standard-button.liquid 中的 emit 初始化脚本不会执行
        // - 导致刷新后的 checkout 按钮无法触发 `cart:checkout`
        // - 这里用冒泡阶段兜底：如果 emit 脚本已生效，它会在 capture 阶段 stopPropagation，本逻辑不会触发
        const checkoutBtn = e?.target?.closest('.ndev-cart-content__checkout-button') ?? null;
        if (checkoutBtn && root.contains(checkoutBtn)) {
          if (checkoutBtn.classList.contains('ndev-standard-button--disabled') || checkoutBtn.disabled) return;
          e.preventDefault();
          e.stopPropagation();
          try {
            if (window.$narwal?.emit && typeof window.$narwal.emit === 'function') {
              window.$narwal.emit('cart:checkout', {});
              return;
            }
          } catch (err) {}

          // 兜底：直接跳转结账
          const rr = getRoutesRoot();
          window.location.href = rr + (rr.endsWith('/') ? 'checkout' : '/checkout');
          return;
        }

        const backLink = e?.target?.closest('[data-continue-back]') ?? null;
        if (backLink && root.contains(backLink)) {
          e.preventDefault();
          e.stopPropagation();
          if (window.history && typeof window.history.back === 'function' && window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = getRoutesRoot();
          }
          return;
        }

        const btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();

        const line = parseInt(btn.getAttribute('data-line'), 10);
        if (!line) return;

        const row = btn.closest('[data-cart-line]');
        const product = getProductNameFromRow(row);
        tryReport(root, 'eventRemove', { btn: 'remove', product: product });

        changeLine(root, line, 0, { btn: 'remove' }).catch(function (err) {
          console.error(err);
        });
      }

      function onCaptureClick(e) {
        const checkoutBtn = e.target && e.target.closest ? e.target.closest('.ndev-cart-content__checkout-button') : null;
        if (!checkoutBtn || !root.contains(checkoutBtn)) return;
        tryReport(root, 'eventCheckout', { btn: 'checkout' });
      }

      root.addEventListener('click', onClick);
      root.addEventListener('click', onCaptureClick, true);

      controllers.set(root, {
        root: root,
        destroy: function () {
          root.removeEventListener('click', onClick);
          root.removeEventListener('click', onCaptureClick, true);
          root.removeAttribute('data-ndev-cart-initialized');
        },
        changeLine: function (line, qty, meta) {
          return changeLine(root, line, qty, meta);
        }
      });
    }

    function initAll() {
      const list = document.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) {
        initOne(list[i]);
      }
    }

    function bindQuantityChange() {
      if (window.ndevCartContentQuantityBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentQuantityBinded = true;
      narwal.bind('quantity:change', function (ev) {
        if (!ev || typeof ev.lineIndex === 'undefined') return;
        const selector = ev.selector;
        const root = selector && selector.closest ? selector.closest(ROOT_SELECTOR) : null;
        if (!root) return;

        const controller = controllers.get(root);
        if (!controller) return;

        const line = parseInt(ev.lineIndex, 10);
        const qty = parseInt(ev.newQuantity, 10);
        if (!line || isNaN(qty)) return;

        const row = root.querySelector('[data-cart-line="' + line + '"]');
        const product = getProductNameFromRow(row);
        tryReport(root, 'eventQtyChange', {
          btn: 'qty_change',
          product: product,
          action: ev.action,
          quantity: qty
        });

        controller.changeLine(line, qty, { btn: 'qty_change', action: ev.action }).catch(function (err) {
          console.error(err);
        });
      });
    }

    function bindQuantityLimit() {
      if (window.ndevCartContentQuantityLimitBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentQuantityLimitBinded = true;
      narwal.bind('quantity:limit', function (ev) {
        const selector = ev && ev.selector;
        const root = selector && selector.closest ? selector.closest(ROOT_SELECTOR) : null;
        if (!root) return;

        const line = parseInt(ev.lineIndex, 10);
        const row = line ? root.querySelector('[data-cart-line="' + line + '"]') : null;
        const product = getProductNameFromRow(row);

        const msg = getText(root, 'textVariantUnavailable', 'Unavailable');
        announce(root, msg);

        tryReport(root, 'eventQtyLimit', {
          btn: 'qty_limit',
          product: product,
          action: ev.action,
          reason: ev.reason,
          attempted_quantity: ev.attemptedQuantity,
          current_quantity: ev.currentQuantity,
          max_quantity: ev.maxQuantity
        });
      });
    }

    // 绑定 narwal 事件（可能晚加载，所以这里既尝试一次，也会在 cart:init / DOMContentLoaded 再尝试）
    bindQuantityChange();
    bindQuantityLimit();
    bindExternalCartChange();
    bindCheckout();

    // 初始化时机：cart api 就绪优先，其次 DOMContentLoaded
    if (window.$narwalCart) {
      initAll();
    } else {
      const narwal = getNarwal();
      if (narwal && typeof narwal.bind === 'function') {
        narwal.bind('cart:init', function () {
          bindQuantityChange();
          bindQuantityLimit();
          bindExternalCartChange();
          bindCheckout();
          initAll();
        });
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          bindQuantityChange();
          bindQuantityLimit();
          bindExternalCartChange();
          bindCheckout();
          initAll();
        });
      }
    }

    // Shopify 主题编辑器事件（仅在 design mode 触发，这里可安全常驻监听）
    document.addEventListener('shopify:section:load', function (event) {
      const sid = event && event.detail ? event.detail.sectionId : '';
      if (!sid) return;
      const root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + String(sid) + '"]');
      if (root) initOne(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const sid = event && event.detail ? event.detail.sectionId : '';
      if (!sid) return;
      const root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + String(sid) + '"]');
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-cart-recommend"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.ndevCartRecommendClientInited) return;
    window.ndevCartRecommendClientInited = true;

    const ROOT_SELECTOR = '.ndev-cart-recommend[data-ndev-cart-recommend]';
    const controllers = window.ndevCartRecommendControllers || (window.ndevCartRecommendControllers = new WeakMap());

    function getNarwal() {
      return (typeof $narwal !== 'undefined') ? $narwal : null;
    }

    function getRoutesRoot() {
      if (window.$narwalCart && typeof window.$narwalCart.routesRoot === 'function') {
        return window.$narwalCart.routesRoot();
      }
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function getCartPath() {
      const root = getRoutesRoot();
      return root + (root.endsWith('/') ? 'cart' : '/cart');
    }

    function setLoading(root, on) {
      if (!root) return;
      if (on) {
        root.classList.add('ndev-cart-recommend--loading');
        root.setAttribute('aria-busy', 'true');
      } else {
        root.classList.remove('ndev-cart-recommend--loading');
        root.removeAttribute('aria-busy');
      }
    }

    /**
     * 只在“页面本来就有遮罩”的情况下续锁：
     * - 典型场景：cart-content 删除/改数量时已锁遮罩，推荐区刷新时补锁，避免遮罩提前消失
     * - 非典型场景：推荐区自己主动刷新（如仅滑动/重绘）不应强制出现遮罩
     */
    function lockOverlayIfActive() {
      const overlay = window.$ndevOverlay;
      if (!overlay || typeof overlay.lock !== 'function' || typeof overlay.getCount !== 'function') return null;
      if (overlay.getCount() <= 0) return null;
      try {
        return overlay.lock({ source: 'ndev-cart-recommend', ariaLabel: 'Loading' });
      } catch (e) {
        return null;
      }
    }

    function destroySwiper(root) {
      if (!root) return;
      const c = controllers.get(root);
      if (c && typeof c.destroy === 'function') {
        try { c.destroy(); } catch (e) {}
      }
      controllers.delete(root);
      root.removeAttribute('data-ndev-cart-recommend-inited');
    }

    function initOne(root) {
      if (!root || root.getAttribute('data-ndev-cart-recommend-inited') === '1') return;
      const wrap =
        root.querySelector('[data-ndev-cart-recommend-swiper-root]') ||
        root.querySelector('.ndev-cart-recommend__swiper-wrap');
      if (!wrap) return;

      const swiperEl = wrap.querySelector('.ndev-cart-recommend__swiper');
      if (!swiperEl) return;

      root.setAttribute('data-ndev-cart-recommend-inited', '1');

      let swiper = null;
      try {
        if (typeof Swiper !== 'undefined') {
          swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: { 1024: { spaceBetween: 20 } },
            navigation: {
              prevEl: wrap.querySelector('[data-ndev-cart-recommend-prev]'),
              nextEl: wrap.querySelector('[data-ndev-cart-recommend-next]'),
              disabledClass: 'swiper-button-disabled',
            },
          });
        }
      } catch (e) {}

      controllers.set(root, {
        swiper: swiper,
        wrap: wrap,
        destroy: function () {
          try {
            swiper && swiper.destroy && swiper.destroy(true, true);
          } catch (e) {}
        }
      });
    }

    function initAll() {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(initOne);
    }

    function emitCartChange(detail) {
      const narwal = getNarwal();
      if (!narwal || typeof narwal.emit !== 'function') return;
      narwal.emit('cart:change', Object.assign({ source: 'ndev-cart-recommend', ts: Date.now() }, detail || {}));
    }

    async function addToCart(variantId) {
      // 优先使用 $narwalCart
      if (window.$narwalCart && typeof window.$narwalCart.addItem === 'function') {
        return await window.$narwalCart.addItem({ variantId: variantId, quantity: 1 });
      }
    }

    let refreshAllInFlight = null;
    let refreshAllQueued = false;

    /**
     * 刷新推荐区：
     * - 合并短时间多次触发（inFlight + queued）
     * - fetch view html 后批量替换每个 root 的 body
     * - 更新 `data-has-recommend` + 重建 Swiper
     *
     * 注意：本函数只刷新推荐区自身，不负责刷新 cart-content。
     * cart-content 的刷新由它自己监听 `cart:change` 完成。
     */
    async function refreshAll() {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      if (!roots || !roots.length) return;

      if (refreshAllInFlight) {
        refreshAllQueued = true;
        return refreshAllInFlight;
      }

      refreshAllInFlight = (async function () {
        const overlayUnlock = lockOverlayIfActive();
        roots.forEach(function (r) { setLoading(r, true); destroySwiper(r); });

        try {
          const url = getCartPath() + '?view=' + encodeURIComponent('cart-recommend');
          const res = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
          });
          if (!res.ok) throw new Error('Failed to refresh cart recommend');

          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;

          const nextBody = tmp.querySelector('[data-ndev-cart-recommend-body]');
          const nextBodyHtml = nextBody ? nextBody.innerHTML : '';

          roots.forEach(function (root) {
            const body = root.querySelector('[data-ndev-cart-recommend-body]');
            if (body) body.innerHTML = nextBodyHtml;

            const hasSlides = !!root.querySelector('.swiper-slide');
            root.setAttribute('data-has-recommend', hasSlides ? '1' : '0');
            if (hasSlides) initOne(root);
          });
        } finally {
          if (typeof overlayUnlock === 'function') {
            try { overlayUnlock(); } catch (e) {}
          }
        }
      })().finally(function () {
        const roots2 = document.querySelectorAll(ROOT_SELECTOR);
        roots2.forEach(function (r) { setLoading(r, false); });

        refreshAllInFlight = null;
        if (refreshAllQueued) {
          refreshAllQueued = false;
          refreshAll();
        }
      });

      return refreshAllInFlight;
    }

    function bindExternalCartChange() {
      if (window.ndevCartRecommendExternalCartChangeBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;
      window.ndevCartRecommendExternalCartChangeBinded = true;
      narwal.bind('cart:change', function () {
        refreshAll().catch(function () {});
      });
    }

    async function handleAddToCart(btn) {
      const variantId = btn && btn.dataset ? btn.dataset.variantId : '';
      if (!variantId) return;

      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');

      // 推荐区“主动加购”必须立刻显示遮罩：
      // 否则会出现：推荐区刷新完了，cart-content 才开始加锁，导致遮罩“晚到”。
      let overlayUnlock = null;
      try {
        if (window.$ndevOverlay && typeof window.$ndevOverlay.lock === 'function') {
          overlayUnlock = window.$ndevOverlay.lock({ source: 'ndev-cart-recommend-atc', ariaLabel: 'Loading' });
        }
      } catch (e) {
        overlayUnlock = null;
      }

      // 让浏览器先渲染出遮罩首帧，再做后续异步请求/DOM 替换
      try {
        await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      } catch (e) {}

      try {
        const result = await addToCart(variantId);
        // ✅ 加购成功后同步 header 数量
        await Promise.allSettled([
          window.$narwalCart?.syncHeaderCartCount?.(),
          refreshAll()
        ]);
        emitCartChange({ action: 'add', variantId: variantId, quantity: 1, result: result });
      } catch (e) {
        // 静默失败：错误提示交给 cart-content/全局兜底
      } finally {
        btn.setAttribute('aria-disabled', 'false');
        if (typeof overlayUnlock === 'function') {
          try { overlayUnlock(); } catch (e) {}
        }
      }
    }

    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest ? e.target.closest('[data-ndev-cart-recommend-atc]') : null;
      if (!btn) return;
      e.preventDefault();
      handleAddToCart(btn);
    });

    // 初始化：即使当前推荐为空也要常驻监听
    bindExternalCartChange();
    document.addEventListener('DOMContentLoaded', function () {
      bindExternalCartChange();
      initAll();
    });
    document.addEventListener('shopify:section:load', function () {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-category-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-category-navbar';
    const ROOT_SELECTOR = '[data-ndev-category-navbar]';
    const ITEM_SELECTOR = '[data-ndev-category-navbar-item]';
    const MAIN_SECTIONS_SELECTOR = '#main-content .shopify-section';
    const SITE_HEADER_SELECTOR = '#site-header';

    const LOCK_IDLE_MS = 220;  // 停止滚动多久后解锁
    const LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    const registryKey = '__ndevSectionControllers__';
    window[registryKey] = window[registryKey] || {};
    window[registryKey][NS] = window[registryKey][NS] || new WeakMap();
    const controllers = window[registryKey][NS];

    function getHeaderOffsetHeight(root, headerEl) {
      let offset = 0;
      if (headerEl) offset += Math.round(headerEl.getBoundingClientRect().height || 0);
      if (root && root.classList.contains('is-sticky')) offset += Math.round(root.getBoundingClientRect().height || 0);
      return offset;
    }

    function updateStickyTop(root, headerEl) {
      if (!root || !root.classList.contains('is-sticky')) return;
      const top = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom || 0) : 0;
      const host = root.__ndevStickyHost && root.__ndevStickyHost.style ? root.__ndevStickyHost : root;
      host.style.setProperty('--ndev-category-navbar-sticky-top', top + 'px');
    }

    function setActive(root, item, state) {
      if (!root || !item || (state && state.activeItem === item)) return;

      root.querySelectorAll(ITEM_SELECTOR).forEach(function (el) {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      item.classList.add('is-active');
      item.setAttribute('aria-current', item.getAttribute('data-item-type') === 'link' ? 'page' : 'true');
      if (state) state.activeItem = item;

      var container = root.querySelector('.ndev-category-navbar__container');
      if (!container) return;
      if (container.scrollWidth <= container.clientWidth + 1) return;
      var r = item.getBoundingClientRect();
      var c = container.getBoundingClientRect();
      var center = (r.left - c.left) + r.width / 2;
      var left = Math.max(0, center - container.clientWidth / 2);
      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      container.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function scrollToAnchorIndex(root, anchorIndex, cachedSections, headerEl) {
      var idx = parseInt(anchorIndex, 10);
      if (!idx || idx < 1) return null;
      var target = cachedSections.length ? cachedSections[idx - 1] : null;
      if (!target || !target.getBoundingClientRect) return null;

      var offset = getHeaderOffsetHeight(root, headerEl);
      var top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
      return { idx: idx, target: target };
    }

    function computeMatchedAnchorIndex(root, anchorItemMap, cachedSections, anchorKeys, headerEl) {
      if (!cachedSections.length) return null;

      var marker = getHeaderOffsetHeight(root, headerEl) + 1;
      var globalIdx = 1;
      for (var i = cachedSections.length - 1; i >= 0; i--) {
        var rect = cachedSections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) { globalIdx = i + 1; break; }
      }

      if (anchorItemMap[globalIdx]) return globalIdx;
      var matched = null;
      for (var j = 0; j < anchorKeys.length; j++) {
        if (anchorKeys[j] <= globalIdx) matched = anchorKeys[j];
      }
      return matched;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      var headerEl = document.querySelector(SITE_HEADER_SELECTOR);
      var mainContent = document.querySelector('#main-content');
      var cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));

      function refreshSectionsCache() {
        cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));
      }

      var mo = null;
      if (mainContent && window.MutationObserver) {
        mo = new MutationObserver(refreshSectionsCache);
        mo.observe(mainContent, { childList: true });
      }

      var state = {
        activeItem: root.querySelector(ITEM_SELECTOR + '.is-active'),
        lock: null
      };

      if (root.classList.contains('is-sticky')) {
        var host = root.closest('.shopify-section') || root.parentElement;
        if (host && host.classList) {
          host.classList.add('ndev-category-navbar__sticky-wrapper');
          root.__ndevStickyHost = host;
        }
      }

      updateStickyTop(root, headerEl);

      var anchorItemMap = {};
      var anchorKeys = [];
      root.querySelectorAll(ITEM_SELECTOR).forEach(function (el) {
        if (el.getAttribute('data-item-type') !== 'anchor') return;
        var ai = parseInt(el.getAttribute('data-anchor-index') || '', 10);
        if (ai) anchorItemMap[ai] = el;
      });
      anchorKeys = Object.keys(anchorItemMap).map(Number).sort(function (a, b) { return a - b; });

      var ticking = false;
      var lockIdleTimer = null;
      var lockMaxTimer = null;
      var unbindUserCancel = null;

      function clearLock() {
        state.lock = null;
        if (lockIdleTimer) { clearTimeout(lockIdleTimer); lockIdleTimer = null; }
        if (lockMaxTimer) { clearTimeout(lockMaxTimer); lockMaxTimer = null; }
        if (unbindUserCancel) { unbindUserCancel(); unbindUserCancel = null; }
      }

      function syncActiveByScroll() {
        if (state.lock) return;
        var matched = computeMatchedAnchorIndex(root, anchorItemMap, cachedSections, anchorKeys, headerEl);
        if (matched !== null && anchorItemMap[matched]) setActive(root, anchorItemMap[matched], state);
      }

      function bindUserIntentCancel() {
        function onWheel() { if (state.lock) clearLock(); }
        function onTouchStart() { if (state.lock) clearLock(); }
        function onPointerDown() { if (state.lock) clearLock(); }
        function onKeyDown(ev) {
          if (!state.lock) return;
          var k = ev && ev.key ? ev.key : '';
          if (k === 'ArrowUp' || k === 'ArrowDown' || k === 'PageUp' || k === 'PageDown' || k === 'Home' || k === 'End' || k === ' ' || k === 'Spacebar') clearLock();
        }
        window.addEventListener('wheel', onWheel, { passive: true, capture: true });
        window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
        window.addEventListener('pointerdown', onPointerDown, { passive: true, capture: true });
        window.addEventListener('keydown', onKeyDown, true);
        return function () {
          window.removeEventListener('wheel', onWheel, true);
          window.removeEventListener('touchstart', onTouchStart, true);
          window.removeEventListener('pointerdown', onPointerDown, true);
          window.removeEventListener('keydown', onKeyDown, true);
        };
      }

      function beginLock() {
        clearLock();
        state.lock = true;
        unbindUserCancel = bindUserIntentCancel();
        lockMaxTimer = setTimeout(function () {
          clearLock();
          syncActiveByScroll();
        }, LOCK_MAX_MS);
      }

      function armIdleUnlock() {
        if (lockIdleTimer) clearTimeout(lockIdleTimer);
        lockIdleTimer = setTimeout(function () {
          if (!state.lock) return;
          clearLock();
          syncActiveByScroll();
        }, LOCK_IDLE_MS);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateStickyTop(root, headerEl);

          if (state.lock) {
            armIdleUnlock();
            return;
          }

          syncActiveByScroll();
        });
      }

      function onClickCapture(ev) {
        var target = ev && ev.target ? ev.target : null;
        if (!target || !target.closest) return;
        var item = target.closest(ITEM_SELECTOR);
        if (!item || !root.contains(item)) return;

        var type = item.getAttribute('data-item-type');
        if (type === 'link') return;

        if (type === 'anchor') {
          ev.preventDefault();
          setActive(root, item, state);
          var info = scrollToAnchorIndex(root, item.getAttribute('data-anchor-index'), cachedSections, headerEl);
          if (info) beginLock();
        }
      }

      function onHeaderFoldChange() {
        updateStickyTop(root, headerEl);
      }

      root.addEventListener('click', onClickCapture);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      if (window.$narwal && $narwal.bind) {
        $narwal.bind('header.fold', onHeaderFoldChange);
        $narwal.bind('header.unfold', onHeaderFoldChange);
      }

      onScroll();

      var ro = null;
      if (headerEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () { updateStickyTop(root, headerEl); onScroll(); });
        ro.observe(headerEl);
      }

      controllers.set(root, {
        destroy: function () {
          clearLock();
          root.removeEventListener('click', onClickCapture);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          if (ro && ro.disconnect) ro.disconnect();
          if (mo && mo.disconnect) mo.disconnect();
          var stickyHost = root.__ndevStickyHost;
          if (stickyHost && stickyHost.classList) stickyHost.classList.remove('ndev-category-navbar__sticky-wrapper');
          delete root.__ndevStickyHost;
        }
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) { initOne(root); });
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) { destroyOne(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-collection-list';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function checkNavigationButtons(root, swiper, swiperEl, navButtons) {
      if (!root || !swiper || !swiperEl || !navButtons) return;
      const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!swiperWrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = swiperWrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.collection-list-swiper');
      const navButtons = root.querySelector('.collection-list__nav-buttons');
      if (!swiperEl) return;

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: root.querySelector('.collection-list__nav-button--next'),
          prevEl: root.querySelector('.collection-list__nav-button--prev'),
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          768: {
            slidesPerView: 6,
            centerInsufficientSlides: true,
          },
        },
        on: {
          init: function () {
            this.el.classList.add('grab');
            window.setTimeout(() => checkNavigationButtons(root, swiper, swiperEl, navButtons), 100);
          },
          sliderMove: function () {
            this.el.classList.add('grabbing');
          },
          slideChangeTransitionEnd: function () {
            this.el.classList.remove('grabbing');
          },
          touchEnd: function () {
            this.el.classList.remove('grabbing');
          },
        },
      });

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(root, swiper, swiperEl, navButtons);
          swiper.update();
        }, 250);
      };

      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, { swiper, onResize });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;

      window.removeEventListener('resize', inst.onResize);
      try {
        inst.swiper.destroy(true, true);
      } catch (e) {}

      root.removeAttribute(INIT_ATTR);
      instances.delete(root);
    }

    function initAll(container = document) {
      const roots = container.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const roots = event.target.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-community-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-community-video';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function getModule(root) {
      const sectionId = root?.dataset?.sectionId || '';
      if (!sectionId) return '';
      const parts = sectionId.split('__');
      return parts[parts.length - 1] || sectionId;
    }

    function checkNavigationButtons(root, swiper, swiperContainer, navButtons) {
      if (!root || !swiper || !swiperContainer || !navButtons) return;
      const wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperContainer.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const swiperContainer = root.querySelector('.swiper-container');
      const navButtons = root.querySelector('.ndev-community-video__nav-buttons');
      const tabItems = Array.from(root.querySelectorAll('.tab-item'));
      const swiperSlides = Array.from(root.querySelectorAll('.swiper-slide'));

      let swiper = null;

      const destroySwiper = () => {
        swiper?.destroy?.(true, true);
        swiper = null;
      };

      const createSwiper = () => {
        if (!swiperContainer || typeof window.Swiper === 'undefined') return;
        destroySwiper();
        swiper = new window.Swiper(swiperContainer, {
          slidesPerView: 'auto',
          initialSlide: 0,
          spaceBetween: 0,
          navigation: {
            nextEl: root.querySelector('.ndev-community-video__nav-button--next'),
            prevEl: root.querySelector('.ndev-community-video__nav-button--prev'),
            disabledClass: 'swiper-button-disabled',
          },
          on: {
            init: function () {
              window.setTimeout(() => checkNavigationButtons(root, swiper, swiperContainer, navButtons), 100);
            },
          },
        });
      };

      const switchTab = (targetCategory) => {
        tabItems.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });

        const targetTab = tabItems.find((item) => item.dataset.category === targetCategory) || null;
        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.setAttribute('aria-selected', 'true');
        }

        swiperSlides.forEach((slide) => {
          const slideCategory = slide.dataset.category;
          if (!slideCategory || slideCategory === targetCategory) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });

        window.setTimeout(() => {
          createSwiper();
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
          swiper?.slideTo?.(0, 0);
        }, 0);

        if (window.$narwal && typeof window.$narwal.report === 'function') {
          window.$narwal.report({
            event: 'tab_switch',
            params: {
              page: 'self',
              module: getModule(root),
              btn: targetTab ? targetTab.textContent.trim() : targetCategory,
            },
          });
        }
      };

      const onTabClick = (ev) => {
        const btn = ev.currentTarget;
        const category = btn?.dataset?.category;
        if (!category) return;
        switchTab(category);
      };

      tabItems.forEach((item) => item.addEventListener('click', onTabClick));

      // initial
      if (tabItems.length > 0) {
        const first = tabItems[0].dataset.category;
        if (first) switchTab(first);
      } else {
        swiperSlides.forEach((slide) => slide.classList.remove('hidden'));
        createSwiper();
        checkNavigationButtons(root, swiper, swiperContainer, navButtons);
      }

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, {
        destroy: () => {
          tabItems.forEach((item) => item.removeEventListener('click', onTabClick));
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          destroySwiper();
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;
      inst.destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-expansion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-expansion';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;
    const instances = new WeakMap();

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperContainer = root.querySelector('.ndev-expansion-pc-cards .swiper-container');
      const paginationEl = root.querySelector('.ndev-expansion-pc-cards .swiper-pagination');
      if (!swiperContainer || !paginationEl) return;

      const pcSwiper = new window.Swiper(swiperContainer, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        autoplay: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          type: 'bullets',
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        try {
          pcSwiper.destroy(true, true);
        } catch (_) {}
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const destroy = instances.get(root);
      if (!destroy) return;
      destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-explore-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-explore-product';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function checkNavigationButtons(swiperEl, navButtons, swiper) {
      if (!swiperEl || !navButtons || !swiper) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.ndev-explore-product-swiper');
      const navButtons = root.querySelector('.ndev-explore-product__nav-buttons');
      if (!swiperEl) return;

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
          nextEl: root.querySelector('.ndev-explore-product__nav-button--next'),
          prevEl: root.querySelector('.ndev-explore-product__nav-button--prev'),
          disabledClass: 'swiper-button-disabled',
        },
        on: {
          init: function () {
            this.el.classList.add('grab');
            window.setTimeout(() => checkNavigationButtons(swiperEl, navButtons, swiper), 100);
          },
          sliderMove: function () {
            this.el.classList.add('grabbing');
          },
          slideChangeTransitionEnd: function () {
            this.el.classList.remove('grabbing');
          },
          touchEnd: function () {
            this.el.classList.remove('grabbing');
          },
        },
      });

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(swiperEl, navButtons, swiper);
          swiper.update();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        window.removeEventListener('resize', onResize);
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        try {
          swiper.destroy(true, true);
        } catch (_) {}
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const destroy = instances.get(root);
      if (!destroy) return;
      destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-navbar';
    const ROOT_SELECTOR = '[data-ndev-navbar]';
    const SCROLL_BTN_SELECTOR = '[data-btn-purpose="scroll"]';
    const MAIN_SECTIONS_SELECTOR = '#main-content .shopify-section';
    const SITE_HEADER_SELECTOR = '#site-header';

    const LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    const LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function getHeaderOffsetHeight(root, headerEl) {
      let offset = 0;
      if (headerEl) offset += Math.round(headerEl.getBoundingClientRect().height || 0);
      if (root && root.classList.contains('is-sticky')) offset += Math.round(root.getBoundingClientRect().height || 0);
      return offset;
    }

    function updateStickyTop(root, headerEl) {
      if (!root || !root.classList.contains('is-sticky')) return;
      requestAnimationFrame(() => {
        const top = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom || 0) : 0;
        const host = root.__ndevStickyHost && root.__ndevStickyHost.style ? root.__ndevStickyHost : root;
        host.style.setProperty('--ndev-navbar-sticky-top', top + 'px');
      })
    }

    function setActive(root, item, state) {
      if (!root || !item) return;

      // item 是带 data-btn-purpose="scroll" 的 <a>/<button> 元素，即内层 .ndev-button__btn
      if (state && state.activeItem === item) return;

      // 只更新导航列表中的按钮（不影响右侧区域）
      var listContainer = root.querySelector('.ndev-navbar__list');
      if (!listContainer) return;

      listContainer.querySelectorAll('.ndev-button .ndev-button__btn').forEach(function (el) {
        el.classList.remove('is-active');
      });

      item.classList.add('is-active');
      if (state) state.activeItem = item;

      // 激活按钮滚动居中（PC 和移动端都适用）
      // 需要找外层 section 来计算滚动位置
      var btnWrapper = item.closest('.ndev-button');
      var r = (btnWrapper || item).getBoundingClientRect();
      var c = listContainer.getBoundingClientRect();
      var center = r.left - c.left + r.width / 2;
      var left = Math.max(0, center - listContainer.clientWidth / 2);
      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      listContainer.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, headerOffset) {
      if (!cachedSections.length) return null;

      var marker = headerOffset + 1;
      var globalIdx = 1;
      for (var i = cachedSections.length - 1; i >= 0; i--) {
        var rect = cachedSections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      var matched = null;
      for (var j = 0; j < anchorKeys.length; j++) {
        if (anchorKeys[j] <= globalIdx) matched = anchorKeys[j];
      }
      return matched;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      var headerEl = document.querySelector(SITE_HEADER_SELECTOR);
      var mainContent = document.querySelector('#main-content');
      var cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));

      function refreshSectionsCache() {
        cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));
      }

      var mo = null;
      if (mainContent && window.MutationObserver) {
        mo = new MutationObserver(refreshSectionsCache);
        mo.observe(mainContent, { childList: true });
      }

      var state = {
        activeItem: null,
        lock: null,
      };

      // 设置 sticky host
      if (root.classList.contains('is-sticky')) {
        var host = root.closest('.shopify-section') || root.parentElement;
        if (host && host.classList) {
          host.classList.add('ndev-navbar__sticky-wrapper');
          root.__ndevStickyHost = host;
        }
      }

      updateStickyTop(root, headerEl);

      // 收集所有带 data-ndev-btn-scroll 属性的按钮，构建映射
      var anchorItemMap = {};
      var anchorKeys = [];
      var listContainer = root.querySelector('.ndev-navbar__list');
      if (listContainer) {
        listContainer.querySelectorAll(SCROLL_BTN_SELECTOR).forEach(function (el) {
          var ai = parseInt(el.getAttribute('data-scroll-section-index') || '', 10);
          if (ai) anchorItemMap[ai] = el;
        });
      }
      anchorKeys = Object.keys(anchorItemMap)
        .map(Number)
        .sort(function (a, b) {
          return a - b;
        });

      // 默认激活第一个
      if (anchorKeys.length > 0 && anchorItemMap[anchorKeys[0]]) {
        setActive(root, anchorItemMap[anchorKeys[0]], state);
      }

      var ticking = false;
      var lockIdleTimer = null;
      var lockMaxTimer = null;
      var unbindUserCancel = null;

      function clearLock() {
        state.lock = null;
        if (lockIdleTimer) {
          clearTimeout(lockIdleTimer);
          lockIdleTimer = null;
        }
        if (lockMaxTimer) {
          clearTimeout(lockMaxTimer);
          lockMaxTimer = null;
        }
        if (unbindUserCancel) {
          unbindUserCancel();
          unbindUserCancel = null;
        }
      }

      function syncActiveByScroll() {
        if (state.lock) return;
        var offset = getHeaderOffsetHeight(root, headerEl);
        var matched = computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, offset);
        if (matched !== null && anchorItemMap[matched]) setActive(root, anchorItemMap[matched], state);
      }

      function bindUserIntentCancel() {
        function onWheel() {
          if (state.lock) clearLock();
        }
        function onTouchStart() {
          if (state.lock) clearLock();
        }
        function onPointerDown() {
          if (state.lock) clearLock();
        }
        function onKeyDown(ev) {
          if (!state.lock) return;
          var k = ev && ev.key ? ev.key : '';
          if (
            k === 'ArrowUp' ||
            k === 'ArrowDown' ||
            k === 'PageUp' ||
            k === 'PageDown' ||
            k === 'Home' ||
            k === 'End' ||
            k === ' ' ||
            k === 'Spacebar'
          )
            clearLock();
        }
        window.addEventListener('wheel', onWheel, { passive: true, capture: true });
        window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
        window.addEventListener('pointerdown', onPointerDown, { passive: true, capture: true });
        window.addEventListener('keydown', onKeyDown, true);
        return function () {
          window.removeEventListener('wheel', onWheel, true);
          window.removeEventListener('touchstart', onTouchStart, true);
          window.removeEventListener('pointerdown', onPointerDown, true);
          window.removeEventListener('keydown', onKeyDown, true);
        };
      }

      function beginLock() {
        clearLock();
        state.lock = true;
        unbindUserCancel = bindUserIntentCancel();
        lockMaxTimer = setTimeout(function () {
          clearLock();
          syncActiveByScroll();
        }, LOCK_MAX_MS);
      }

      function armIdleUnlock() {
        if (lockIdleTimer) clearTimeout(lockIdleTimer);
        lockIdleTimer = setTimeout(function () {
          if (!state.lock) return;
          clearLock();
          syncActiveByScroll();
        }, LOCK_IDLE_MS);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateStickyTop(root, headerEl);

          if (state.lock) {
            armIdleUnlock();
            return;
          }

          syncActiveByScroll();
        });
      }

      // 监听按钮点击（capture 阶段），设置锁定
      function onClickCapture(ev) {
        var target = ev && ev.target ? ev.target : null;
        if (!target || !target.closest) return;
        var btn = target.closest(SCROLL_BTN_SELECTOR);
        if (!btn || !root.contains(btn)) return;

        // 立即设置激活状态
        setActive(root, btn, state);

        // 设置锁定，防止滚动回显覆盖
        beginLock();
      }

      root.addEventListener('click', onClickCapture, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      onScroll();

      var ro = null;
      if (headerEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () {
          updateStickyTop(root, headerEl);
          onScroll();
        });
        ro.observe(headerEl);
      }

      controllers.set(root, {
        destroy: function () {
          clearLock();
          root.removeEventListener('click', onClickCapture, true);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          if (ro && ro.disconnect) ro.disconnect();
          if (mo && mo.disconnect) mo.disconnect();
          var stickyHost = root.__ndevStickyHost;
          if (stickyHost && stickyHost.classList) stickyHost.classList.remove('ndev-navbar__sticky-wrapper');
          delete root.__ndevStickyHost;
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        initOne(root);
      });
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        destroyOne(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-standard-accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const swiperMap = new WeakMap();

    function getState(root) {
      if (!swiperMap.has(root)) {
        swiperMap.set(root, { swipers: {}, activeGroup: 0 });
      }
      return swiperMap.get(root);
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function renderPagination(current, total) {
      return '<div class="ndev-standard-accessories__pagination-info">' +
        '<span class="ndev-standard-accessories__pagination-current">' + formatPageNum(current) + '</span>' +
        '<span class="ndev-standard-accessories__pagination-total">/' + formatPageNum(total) + '</span>' +
        '</div>' +
        '<div class="ndev-standard-accessories__pagination-buttons">' +
        '<button class="ndev-standard-accessories__pagination-button ndev-standard-accessories__pagination-button--prev" type="button" aria-label="Previous slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button class="ndev-standard-accessories__pagination-button ndev-standard-accessories__pagination-button--next" type="button" aria-label="Next slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div>';
    }

    function checkNavigationButtons(root, group) {
      const state = getState(root);
      const swiper = state.swipers[group];
      if (!swiper) return;
      const swiperEl = root.querySelector('[data-swiper-instance="' + group + '"]');
      let navButtons = root.querySelector('[data-nav-prev="' + group + '"]');
      if (!swiperEl || !navButtons) return;
      navButtons = navButtons.closest('.ndev-standard-accessories__nav-buttons');
      if (!navButtons) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      if (wrapper.scrollWidth > swiperEl.offsetWidth + 1) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function destroySwiper(root, group) {
      const state = getState(root);
      const swiper = state.swipers[group];
      if (swiper) {
        const pagKey = '_pag' + group;
        const pag = state[pagKey];
        if (pag && pag.el) pag.el.removeEventListener('click', pag.handler);
        delete state[pagKey];
        try { swiper.destroy(true, true); } catch (e) {}
        delete state.swipers[group];
      }
    }

    function initSwiper(root, group) {
      if (typeof window.Swiper === 'undefined') return;
      const state = getState(root);
      if (state.swipers[group]) return;
      const groupEl = root.querySelector('[data-tab-group="' + group + '"]');
      if (!groupEl) return;
      const swiperEl = groupEl.querySelector('[data-swiper-instance="' + group + '"]');
      const paginationEl = groupEl.querySelector('[data-pagination="' + group + '"]');
      const navPrevEl = groupEl.querySelector('[data-nav-prev="' + group + '"]');
      const navNextEl = groupEl.querySelector('[data-nav-next="' + group + '"]');
      if (!swiperEl) return;

      const enableSideNav = root.getAttribute('data-nav-side') !== 'false';
      const enablePagPc = root.getAttribute('data-pagination-pc') !== 'false';
      const enablePagMb = root.getAttribute('data-pagination-mb') !== 'false';
      const isMobile = window.innerWidth < 768;
      const enablePagination = isMobile ? enablePagMb : enablePagPc;

      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
        on: {
          init: function () {
            if (enableSideNav) {
              window.setTimeout(() => checkNavigationButtons(root, group), 100);
            }
          },
          resize: function () {
            if (enableSideNav) {
              checkNavigationButtons(root, group);
            }
          }
        }
      };

      if (enableSideNav && navNextEl && navPrevEl) {
        config.navigation = {
          nextEl: navNextEl,
          prevEl: navPrevEl,
          disabledClass: 'swiper-button-disabled'
        };
      }

      if (enablePagination && paginationEl) {
        config.pagination = {
          el: paginationEl,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            if (total <= 1) return '';
            return renderPagination(current, total);
          }
        };
      }

      const swiper = new window.Swiper(swiperEl, config);
      state.swipers[group] = swiper;

      if (enablePagination && paginationEl) {
        const handlePaginationClick = (e) => {
          let target = e.target;
          while (target && target !== paginationEl) {
            if (target.classList && target.classList.contains('ndev-standard-accessories__pagination-button--prev')) {
              swiper.slidePrev();
              return;
            }
            if (target.classList && target.classList.contains('ndev-standard-accessories__pagination-button--next')) {
              swiper.slideNext();
              return;
            }
            target = target.parentElement;
          }
        };
        paginationEl.addEventListener('click', handlePaginationClick);
        state['_pag' + group] = { el: paginationEl, handler: handlePaginationClick };
      }
    }

    function switchTab(root, targetIndex) {
      const state = getState(root);
      if (targetIndex === state.activeGroup) return;

      destroySwiper(root, state.activeGroup);

      const oldGroup = root.querySelector('[data-tab-group="' + state.activeGroup + '"]');
      const newGroup = root.querySelector('[data-tab-group="' + targetIndex + '"]');
      if (oldGroup) oldGroup.setAttribute('hidden', '');
      if (newGroup) newGroup.removeAttribute('hidden');

      root.querySelectorAll('.ndev-standard-accessories__tab').forEach((tab) => {
        const idx = parseInt(tab.getAttribute('data-tab-index'), 10);
        tab.setAttribute('aria-selected', idx === targetIndex ? 'true' : 'false');
      });

      state.activeGroup = targetIndex;
      initSwiper(root, targetIndex);
    }

    function init(root) {
      if (!root) return;

      root.querySelectorAll('.ndev-standard-accessories__tab').forEach((tab) => {
        tab.addEventListener('click', () => {
          const idx = parseInt(tab.getAttribute('data-tab-index'), 10);
          switchTab(root, idx);
        });
      });

      const eventName = root.getAttribute('data-id') + ':tab-change';
      document.addEventListener(eventName, function (e) {
        const value = e.detail && e.detail.value;
        if (value == null) return;
        switchTab(root, parseInt(value, 10));
      });

      const state = getState(root);
      const defaultActiveTab = root.querySelector('.ndev-standard-accessories__tab[data-tab-index="0"]');
      if (defaultActiveTab && defaultActiveTab.getAttribute('aria-selected') === 'true') {
        state.activeGroup = 0;
      }

      initSwiper(root, state.activeGroup);
    }

    function dispose(root) {
      if (!root) return;
      const state = getState(root);
      Object.keys(state.swipers).forEach((k) => {
        destroySwiper(root, parseInt(k, 10));
      });
      swiperMap.delete(root);
    }

    ComponentRegistry.register({
      ns: 'ndev-standard-accessories',
      mode: 'component',
      selector: '[data-ndev-accessories]',
      init: init,
      dispose: dispose
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-all-purpose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-all-purpose')) {
    class NdevV50AllPurpose extends BaseElement {
      init() {
        this.introTravelVh = this.readNumber('intro-travel-vh', 118);
        this.frameHeightVh = this.readNumber('frame-height-vh', 220);
        this.topExitGapPc = this.readNumber('top-exit-gap-pc', 0);
        this.topExitGapMb = this.readNumber('top-exit-gap-mb', 0);
        this.track = this.querySelector('.ndev-v50-all-purpose__track');
        this.viewport = this.querySelector('.ndev-v50-all-purpose__viewport');
        this.introContent = this.querySelector('[v50-all-purpose-intro-content]');
        this.frame = this.querySelector('[v50-all-purpose-frame]');
        this._mq = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.raf = 0;
        this.frameActive = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onViewportModeChange = this.requestUpdate.bind(this);
        this.onMotionChange = () => {
          this.frameActive = null;
          this.requestUpdate();
        };

        this.classList.add('is-ready');
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (this._mq.addEventListener) {
          this._mq.addEventListener('change', this.onViewportModeChange);
        } else if (this._mq.addListener) {
          this._mq.addListener(this.onViewportModeChange);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this.onViewportModeChange);
        } else if (this._mq.removeListener) {
          this._mq.removeListener(this.onViewportModeChange);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.classList.remove('is-ready');
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.update());
      }

      getReservedTop(isDesktop) {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        const extra = isDesktop ? this.topExitGapPc : this.topExitGapMb;
        return header + navbar + extra;
      }

      getCssNumber(name, fallback) {
        const value = parseFloat(getComputedStyle(this).getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      }

      update() {
        this.raf = 0;

        const vh = this.viewport ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1 : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const trackTop = this.track ? this.track.getBoundingClientRect().top + scrollTop : this.getBoundingClientRect().top + scrollTop;
        const introPx = (this.introTravelVh / 100) * vh;
        const frameHoldPx = (this.frameHeightVh / 100) * vh;
        const totalTravel = Math.max(0, scrollTop - trackTop);
        const travel = this.clamp(totalTravel, 0, introPx);
        const isDesktop = this._mq.matches;

        const introOffset = this.reducedMotion.matches && travel > 0 ? -introPx : -travel;
        this.style.setProperty('--v50-all-purpose-intro-content-y', introOffset.toFixed(2) + 'px');

        const reservedTop = this.getReservedTop(isDesktop);
        const introContentRect = this.introContent ? this.introContent.getBoundingClientRect() : null;
        const exitPx = introContentRect ? travel + Math.max(0, introContentRect.bottom - reservedTop) : introPx;
        const overlayEndPx = Math.max(1, Math.min(exitPx, introPx));
        const frameStartPx = Math.max(1, Math.min(exitPx, introPx));
        const overlayProgress = this.clamp(travel / overlayEndPx, 0, 1);
        const maskStart = this.getCssNumber('--v50-all-purpose-mask-start-opacity', 0.6);
        const maskEnd = this.getCssNumber('--v50-all-purpose-mask-end-opacity', 0);
        const maskOpacity = maskStart + (maskEnd - maskStart) * overlayProgress;
        const frameActive = totalTravel >= frameStartPx;
        const frameProgress = frameHoldPx > 0 ? this.clamp((totalTravel - frameStartPx) / frameHoldPx, 0, 1) : Number(frameActive);

        this.style.setProperty('--v50-all-purpose-mask-opacity', maskOpacity.toFixed(4));
        this.style.setProperty('--v50-all-purpose-gradient-opacity', maskOpacity.toFixed(4));
        this.setFrameActive(frameActive);
        this.dispatchFrameProgress(frameActive, frameProgress);
      }

      setFrameActive(active) {
        if (this.frameActive === active) return;
        this.frameActive = active;
        this.classList.toggle('is-frame-active', active);
        if (this.introContent) this.introContent.setAttribute('aria-hidden', active ? 'true' : 'false');
        if (this.frame) this.frame.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      dispatchFrameProgress(active, progress) {
        this.dispatchEvent(new CustomEvent('ndev-v50-frame-progress', {
          detail: {
            active,
            progress,
          },
        }));
      }
    }

    customElements.define('ndev-v50-all-purpose', NdevV50AllPurpose);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-anti-tangle-animation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-anti-tangle-animation')) {
    class NdevV50AntiTangleAnimation extends BaseElement {
      init() {
        this.endTriggerVh = this.readNumber('end-trigger-vh', 100);
        this.viewport = this.querySelector('.ndev-v50-anti-tangle-animation__viewport');
        this.middleStage = this.querySelector('.ndev-v50-anti-tangle-animation__stage--middle');
        this.endStage = this.querySelector('.ndev-v50-anti-tangle-animation__stage--end');
        this.media = this.querySelector('.ndev-v50-anti-tangle-animation__media-block');
        this.desktopVideo = this.media?.querySelector('.show-pc video.ndev-media__video') || null;
        this.mobileVideo = this.media?.querySelector('.show-mb video.ndev-media__video') || null;
        this.videos = Array.from(this.media?.querySelectorAll('video.ndev-media__video') || []);
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.state = null;
        this.inView = false;
        this.readyFrame = 0;
        this.observer = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onLayoutChange = this.handleEnvironmentChange.bind(this);
        this.onVisibilityChange = this.syncVideo.bind(this);
        this.onIntersection = this.handleIntersection.bind(this);

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addMediaListener(this.desktopMedia, this.onLayoutChange);
        this.addMediaListener(this.reducedMotion, this.onLayoutChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0.1 });
          this.observer.observe(this);
        } else {
          this.inView = true;
        }

        this.update({ initial: true });
        this.readyFrame = requestAnimationFrame(() => {
          this.readyFrame = requestAnimationFrame(() => this.classList.add('is-ready'));
        });
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeMediaListener(this.desktopMedia, this.onLayoutChange);
        this.removeMediaListener(this.reducedMotion, this.onLayoutChange);
        if (this.observer) this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.readyFrame) cancelAnimationFrame(this.readyFrame);
        this.pauseVideos();
        this.classList.remove('is-ready');
        this.frame = 0;
        this.readyFrame = 0;
      }

      addMediaListener(query, listener) {
        if (query.addEventListener) query.addEventListener('change', listener);
        else query.addListener(listener);
      }

      removeMediaListener(query, listener) {
        if (query.removeEventListener) query.removeEventListener('change', listener);
        else query.removeListener(listener);
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      handleEnvironmentChange() {
        this.state = null;
        this.requestUpdate();
        this.syncVideo();
      }

      handleIntersection(entries) {
        const entry = entries.find((item) => item.target === this);
        if (!entry) return;
        this.inView = entry.isIntersecting;
        this.syncVideo();
      }

      update(options = {}) {
        this.frame = 0;

        if (!this.desktopMedia.matches || this.reducedMotion.matches) {
          this.setState('static', options.initial);
          this.syncVideo();
          return;
        }

        const viewportHeight = this.viewport
          ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1
          : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rootTop = this.getBoundingClientRect().top + scrollTop;
        const travel = scrollTop - rootTop;
        const endTrigger = (this.endTriggerVh / 100) * viewportHeight;
        const nextState = travel < 0 ? 'intro' : travel < endTrigger ? 'middle' : 'end';

        this.setState(nextState, options.initial);
        this.syncVideo();
      }

      setState(nextState, force) {
        if (!force && this.state === nextState) return;
        this.state = nextState;
        this.setAttribute('state', nextState);

        const showAll = nextState === 'static';
        if (this.middleStage) {
          this.middleStage.setAttribute('aria-hidden', showAll || nextState === 'middle' ? 'false' : 'true');
        }
        if (this.endStage) {
          this.endStage.setAttribute('aria-hidden', showAll || nextState === 'end' ? 'false' : 'true');
        }
      }

      syncVideo() {
        if (!this.videos.length) return;
        const activeVideo = this.desktopMedia.matches ? this.desktopVideo : this.mobileVideo;
        const shouldPlay = this.inView && !this.reducedMotion.matches && !document.hidden;

        this.videos.forEach((video) => {
          if (!shouldPlay || video !== activeVideo) this.pauseVideo(video);
        });

        if (!shouldPlay || !activeVideo) {
          return;
        }

        activeVideo.muted = true;
        const promise = activeVideo.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      }

      pauseVideo(video) {
        try {
          video.pause();
        } catch (error) {}
      }

      pauseVideos() {
        this.videos.forEach((video) => this.pauseVideo(video));
      }
    }

    customElements.define('ndev-v50-anti-tangle-animation', NdevV50AntiTangleAnimation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-dirt-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-dirt-overview')) {
    class NdevV50DirtOverview extends BaseElement {
      init() {
        this.introTravelVh = this.readNumber('intro-travel-vh', 110);
        this.metricsTravelVh = this.readNumber('metrics-travel-vh', 92);
        this.maskStartPc = this.readNumber('intro-mask-start-pc', 0.6);
        this.maskEndPc = this.readNumber('intro-mask-end-pc', 0);
        this.maskStartMb = this.readNumber('intro-mask-start-mb', 0.8);
        this.maskEndMb = this.readNumber('intro-mask-end-mb', 0.4);
        this.viewport = this.querySelector('.ndev-v50-dirt-overview__viewport');
        this.introEl = this.querySelector('.ndev-v50-dirt-overview-intro');
        this.metricsEl = this.querySelector('.ndev-v50-dirt-overview-metrics');
        this.countups = Array.from(this.querySelectorAll('ndev-scroll-countup'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.countupTimer = 0;
        this.countupsActive = false;
        this.metricsActive = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onMotionChange = () => {
          this.metricsActive = null;
          this.requestUpdate();
        };

        this.classList.add('is-ready');
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.countupTimer) clearTimeout(this.countupTimer);
        this.classList.remove('is-ready');
        this.frame = 0;
        this.countupTimer = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;

        if (this.reducedMotion.matches) {
          this.style.setProperty('--v50-dirt-intro-y', '0vh');
          this.style.setProperty('--v50-dirt-intro-opacity', '1');
          this.style.setProperty('--v50-dirt-mask-opacity', '0');
          if (this.countupTimer) clearTimeout(this.countupTimer);
          this.countupTimer = 0;
          this.metricsActive = false;
          this.classList.remove('is-metrics-active');
          if (this.introEl) this.introEl.setAttribute('aria-hidden', 'false');
          if (this.metricsEl) this.metricsEl.setAttribute('aria-hidden', 'false');
          this.setCountupsActive(true);
          return;
        }

        const vh = this.viewport ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1 : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rootTop = this.getBoundingClientRect().top + scrollTop;
        const introPx = (this.introTravelVh / 100) * vh;
        const metricsPx = (this.metricsTravelVh / 100) * vh;
        const totalPx = introPx + metricsPx;
        const travel = this.clamp(scrollTop - rootTop, 0, totalPx);
        const introProgress = introPx > 0 ? this.clamp(travel / introPx, 0, 1) : 1;
        const metricsActive = travel >= introPx;
        const isDesktop = this._mq ? this._mq.matches : window.matchMedia('(min-width: 1024px)').matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const maskEnd = isDesktop ? this.maskEndPc : this.maskEndMb;
        const maskOpacity = maskStart + (maskEnd - maskStart) * introProgress;
        const introShiftVh = isDesktop ? -32 : -36;
        const introY = introProgress * introShiftVh;

        this.style.setProperty('--v50-dirt-intro-y', introY.toFixed(3) + 'vh');
        this.style.setProperty('--v50-dirt-intro-opacity', '1');
        this.style.setProperty('--v50-dirt-mask-opacity', maskOpacity.toFixed(4));
        this.setMetricsActive(metricsActive);
      }

      setMetricsActive(active) {
        if (this.metricsActive === active) return;
        this.metricsActive = active;
        this.classList.toggle('is-metrics-active', active);
        if (this.introEl) this.introEl.setAttribute('aria-hidden', active ? 'true' : 'false');
        if (this.metricsEl) this.metricsEl.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (this.countupTimer) clearTimeout(this.countupTimer);
        this.countupTimer = 0;

        if (active) {
          this.countupTimer = window.setTimeout(() => {
            this.countupTimer = 0;
            this.setCountupsActive(true);
          }, 180);
        } else {
          this.setCountupsActive(false);
        }
      }

      setCountupsActive(active) {
        if (this.countupsActive === active) return;
        this.countupsActive = active;

        this.countups.forEach((countup) => {
          if (active) {
            countup.setAttribute('active', '');
          } else {
            countup.removeAttribute('active');
          }
        });
      }
    }

    customElements.define('ndev-v50-dirt-overview', NdevV50DirtOverview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-dirtscan"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-dirtscan')) {
    class NdevV50Dirtscan extends BaseElement {
      init() {
        this.activationTravelVh = this.readNumber('activation-travel-vh', 24);
        this.track = this.querySelector('.ndev-v50-dirtscan__track');
        this.viewport = this.querySelector('.ndev-v50-dirtscan__viewport');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.lightOn = this.classList.contains('is-light-on');
        this.raf = 0;
        this.onViewportChange = this.requestUpdate.bind(this);
        this.onMotionChange = this.requestUpdate.bind(this);

        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange, { passive: true });
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      smoothstep(value) {
        return value * value * (3 - 2 * value);
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.update());
      }

      getReservedTop() {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        return header + navbar;
      }

      setLightOn() {
        if (this.lightOn) return;
        this.lightOn = true;
        this.classList.add('is-light-on');
      }

      update() {
        this.raf = 0;

        if (!this.track || !this.viewport) return;

        if (this.reducedMotion.matches) {
          this.setLightOn();
          this.style.setProperty('--v50-dirtscan-exit-progress', '0');
          return;
        }

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const trackTop = this.track.getBoundingClientRect().top + scrollTop;
        const travel = scrollTop - trackTop;
        const activationTravel = Math.max((this.activationTravelVh / 100) * viewportHeight, this.getReservedTop());

        if (!this.lightOn && travel >= activationTravel) this.setLightOn();

        const stickyTravel = Math.max(1, this.track.offsetHeight - viewportHeight);
        const exitStart = stickyTravel * 0.58;
        const exitLinearProgress = this.clamp((travel - exitStart) / Math.max(1, stickyTravel - exitStart), 0, 1);
        const exitProgress = this.smoothstep(exitLinearProgress);
        this.style.setProperty('--v50-dirtscan-exit-progress', exitProgress.toFixed(4));
      }
    }

    customElements.define('ndev-v50-dirtscan', NdevV50Dirtscan);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-free-in-coverage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-free-in-coverage')) {
    class NdevV50FreeInCoverage extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-free-in-coverage__track');
        this.viewport = this.querySelector('.ndev-v50-free-in-coverage__viewport');
        this.content = this.querySelector('.ndev-v50-free-in-coverage__content');
        this.maskStartPc = this.readNumber('mask-start-pc', 0.6);
        this.maskStartMb = this.readNumber('mask-start-mb', 0.5);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.contentTravel = 0;
        this.mobileTarget = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
        this.mobileImageScale = 1;
        this.mobileImageFinalY = 0;
        this.frame = 0;
        this.isNear = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.recalculate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.content);
        } else {
          window.addEventListener('resize', this.onResize, { passive: true });
        }

        this.recalculate();
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        } else {
          window.removeEventListener('resize', this.onResize);
        }
        this.resizeObserver = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      lerp(start, end, progress) {
        return start + (end - start) * progress;
      }

      getReservedTop() {
        const stickyTop = parseFloat(getComputedStyle(this.viewport).top);
        return Number.isFinite(stickyTop) ? stickyTop : 0;
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.recalculate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        this.recalculate();
      }

      recalculate() {
        if (!this.track || !this.viewport || !this.content) return;

        const viewportRect = this.viewport.getBoundingClientRect();
        const contentRect = this.content.getBoundingClientRect();
        const isDesktop = this._mq.matches;
        const finalTop = isDesktop ? 128 : 32;

        this.viewportWidth = viewportRect.width || window.innerWidth || 1;
        this.viewportHeight = viewportRect.height || window.innerHeight || 1;
        this.contentTravel = Math.max(0, (this.viewportHeight - contentRect.height) / 2 - finalTop);

        const mobileMediaTop = finalTop + contentRect.height + 24;
        const availableWidth = Math.max(0, Math.min(342, this.viewportWidth - 48));
        const availableHeight = Math.max(0, this.viewportHeight - mobileMediaTop - 24);
        const mobileWidth = Math.min(availableWidth, availableHeight * 342 / 300);
        const mobileHeight = mobileWidth * 300 / 342;
        const mobileLeft = (this.viewportWidth - mobileWidth) / 2;
        const mobileRight = this.viewportWidth - mobileLeft - mobileWidth;
        const mobileBottom = this.viewportHeight - mobileMediaTop - mobileHeight;

        this.mobileTarget = {
          top: mobileMediaTop,
          right: Math.max(0, mobileRight),
          bottom: Math.max(0, mobileBottom),
          left: Math.max(0, mobileLeft),
          width: mobileWidth,
          height: mobileHeight,
        };
        this.mobileImageScale = mobileHeight / this.viewportHeight;
        this.mobileImageFinalY = mobileMediaTop + mobileHeight / 2 - this.viewportHeight / 2;

        this.style.setProperty('--v50-free-in-coverage-mb-target-width', mobileWidth.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-target-height', mobileHeight.toFixed(2) + 'px');
        this.classList.add('is-ready');

        if (this.reducedMotion.matches) {
          this.applyProgress(1);
        } else {
          this.requestUpdate();
        }
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const reservedTop = this.getReservedTop();
        const scrollDistance = Math.max(1, trackRect.height - this.viewportHeight);
        const progress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);

        this.applyProgress(progress);
      }

      applyProgress(progress) {
        const safeProgress = this.clamp(progress, 0, 1);
        const isDesktop = this._mq.matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const contentY = this.contentTravel * (1 - safeProgress);
        const maskOpacity = maskStart * (1 - safeProgress);
        const pcImageScale = this.lerp(1.395, 1, safeProgress);
        const pcGradientOpacity = 0.3 * safeProgress;
        const mobileGradientOpacity = 1 - safeProgress;
        const mobileImageScale = this.lerp(1, this.mobileImageScale, safeProgress);
        const mobileImageStartX = -this.viewportWidth * 0.13333;
        const mobileImageX = this.lerp(mobileImageStartX, 0, safeProgress);
        const mobileImageY = this.mobileImageFinalY * safeProgress;

        this.style.setProperty('--v50-free-in-coverage-content-y', contentY.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mask-opacity', maskOpacity.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-pc-image-scale', pcImageScale.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-pc-gradient-opacity', pcGradientOpacity.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-mb-gradient-opacity', mobileGradientOpacity.toFixed(4));
        this.style.setProperty(
          '--v50-free-in-coverage-clip-top',
          (this.mobileTarget.top * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-right',
          (this.mobileTarget.right * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-bottom',
          (this.mobileTarget.bottom * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-left',
          (this.mobileTarget.left * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty('--v50-free-in-coverage-clip-radius', (8 * safeProgress).toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-image-scale', mobileImageScale.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-mb-image-x', mobileImageX.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-image-y', mobileImageY.toFixed(2) + 'px');
      }
    }

    customElements.define('ndev-v50-free-in-coverage', NdevV50FreeInCoverage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-free-in-hand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-free-in-hand')) {
    class NdevV50FreeInHand extends BaseElement {
      init() {
        this.viewport = this.querySelector('.ndev-v50-free-in-hand__viewport');
        this.content = this.querySelector('.ndev-v50-free-in-hand__content');
        this.maskStartPc = this.readNumber('mask-start-pc', 0.6);
        this.maskStartMb = this.readNumber('mask-start-mb', 0.8);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.travelPx = 1;
        this.frame = 0;
        this.isActive = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.recalculate.bind(this);
        this.onMotionChange = this.recalculate.bind(this);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setActive(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setActive(true);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.content);
        } else {
          window.addEventListener('resize', this.onResize, { passive: true });
        }

        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }

        this.recalculate();
      }

      dispose() {
        this.setActive(false);
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        } else {
          window.removeEventListener('resize', this.onResize);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      setActive(active) {
        if (this.isActive === active) return;
        this.isActive = active;

        if (active) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.recalculate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }

      recalculate() {
        if (!this.viewport || !this.content) return;

        if (this.reducedMotion.matches) {
          this.style.setProperty('--v50-free-in-hand-content-y', '0px');
          this.style.setProperty('--v50-free-in-hand-mask-opacity', '0');
          return;
        }

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const contentHeight = this.content.getBoundingClientRect().height;
        const finalTop = this.content.offsetTop;
        const centeredTop = Math.max(0, (viewportHeight - contentHeight) / 2);
        const travelPx = Math.max(0, centeredTop - finalTop);

        this.travelPx = Math.max(travelPx, 1);
        this.style.setProperty('--v50-free-in-hand-content-y', travelPx.toFixed(2) + 'px');
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (this.reducedMotion.matches) return;

        const travel = this.clamp(-this.getBoundingClientRect().top, 0, this.travelPx);
        const progress = this.travelPx > 0 ? travel / this.travelPx : 1;
        const isDesktop = this._mq ? this._mq.matches : window.matchMedia('(min-width: 1024px)').matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const contentY = this.travelPx - travel;
        const maskOpacity = maskStart * (1 - progress);

        this.style.setProperty('--v50-free-in-hand-content-y', contentY.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-hand-mask-opacity', maskOpacity.toFixed(4));
      }
    }

    customElements.define('ndev-v50-free-in-hand', NdevV50FreeInHand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-lightweight-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-lightweight-scenes')) {
    class NdevV50LightweightScenes extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-lightweight-scenes__track');
        this.viewport = this.querySelector('.ndev-v50-lightweight-scenes__viewport');
        this.rail = this.querySelector('.ndev-v50-lightweight-scenes__rail');
        this.cards = Array.from(this.querySelectorAll('.ndev-v50-lightweight-scene-card'));
        this.segments = Array.from(this.querySelectorAll('.ndev-v50-lightweight-scenes__progress-segment'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.isNear = false;
        this.activeIndex = -1;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.requestUpdate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if (!this.cards.length) return;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        this.applyProgress(0);
        this.classList.add('is-ready');
        this.requestUpdate();
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.requestUpdate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        this.activeIndex = -1;
        if (this.reducedMotion.matches) this.applyProgress(0);
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame || !this.cards.length) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = parseFloat(getComputedStyle(this).getPropertyValue('--v50-lightweight-reserved-top')) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const linearProgress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);
        const maxIndex = Math.max(0, this.cards.length - 1);
        const rawStep = linearProgress * maxIndex;
        const stepIndex = Math.min(maxIndex, Math.floor(rawStep));
        const fraction = stepIndex >= maxIndex ? 0 : rawStep - stepIndex;
        const heldFraction = this.clamp((fraction - 0.1) / 0.8, 0, 1);
        const easedFraction = 0.5 - Math.cos(Math.PI * heldFraction) / 2;
        const sceneProgress = Math.min(maxIndex, stepIndex + easedFraction);

        this.applyProgress(sceneProgress);
      }

      applyProgress(progress) {
        if (!this.cards.length || !this.viewport || !this.rail) return;

        const maxIndex = this.cards.length - 1;
        const safeProgress = this.clamp(progress, 0, maxIndex);
        const baseIndex = Math.min(maxIndex, Math.floor(safeProgress));
        const nextIndex = Math.min(maxIndex, baseIndex + 1);
        const localProgress = nextIndex === baseIndex ? 0 : safeProgress - baseIndex;
        const isDesktop = this._mq.matches && !this.reducedMotion.matches;
        const viewportWidth = this.viewport.getBoundingClientRect().width || window.innerWidth || 1;
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;

        if (isDesktop) {
          this.applyDesktopLayout(baseIndex, nextIndex, localProgress, viewportWidth, viewportHeight);
        } else if (!this.reducedMotion.matches) {
          this.rail.style.transform = `translate3d(${-safeProgress * viewportWidth}px, 0, 0)`;
          this.cards.forEach((card, index) => {
            const focus = index === baseIndex ? 1 - localProgress : index === nextIndex ? localProgress : 0;
            this.setCardVisualState(card, focus);
          });
        } else {
          this.rail.style.transform = '';
          this.cards.forEach((card) => this.setCardVisualState(card, 1));
        }

        this.segments.forEach((segment, index) => {
          const fill = this.clamp(safeProgress - index + 1, 0, 1);
          segment.style.setProperty('--v50-lightweight-progress-fill', fill.toFixed(4));
        });

        this.setActiveIndex(Math.round(safeProgress));
      }

      applyDesktopLayout(baseIndex, nextIndex, localProgress, viewportWidth, viewportHeight) {
        const copyTop = this.clamp(viewportHeight * 0.1296, 40, 128);
        const bottomSpace = this.clamp(viewportHeight * 0.0324, 24, 32);
        const activeSize = Math.min(
          708,
          viewportWidth * 0.6,
          Math.max(224, viewportHeight - copyTop - 152 - bottomSpace)
        );
        const thumbSize = Math.min(224, viewportWidth * 0.2, activeSize);
        const galleryCenter = copyTop + 152 + activeSize / 2;
        const gap = 20;
        const centers = [];
        let cursor = 0;

        this.style.setProperty('--v50-lightweight-copy-top', `${copyTop.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-active-size', `${activeSize.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-thumb-size', `${thumbSize.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-gallery-center', `${galleryCenter.toFixed(2)}px`);

        this.cards.forEach((card, index) => {
          const focus = index === baseIndex ? 1 - localProgress : index === nextIndex ? localProgress : 0;
          const size = thumbSize + (activeSize - thumbSize) * focus;
          card.style.setProperty('--v50-lightweight-card-size', `${size.toFixed(2)}px`);
          this.setCardVisualState(card, focus);
          centers[index] = cursor + size / 2;
          cursor += size + gap;
        });

        const targetCenter = centers[baseIndex] + (centers[nextIndex] - centers[baseIndex]) * localProgress;
        const offset = viewportWidth / 2 - targetCenter;
        this.rail.style.transform = `translate3d(${offset.toFixed(2)}px, 0, 0)`;
      }

      setCardVisualState(card, focus) {
        const safeFocus = this.clamp(focus, 0, 1);
        card.style.setProperty('--v50-lightweight-card-radius', `${(4 + safeFocus * 4).toFixed(2)}px`);
        card.style.setProperty('--v50-lightweight-media-opacity', (0.5 + safeFocus * 0.5).toFixed(4));
        card.style.setProperty('--v50-lightweight-copy-opacity', safeFocus.toFixed(4));
      }

      setActiveIndex(index) {
        const nextIndex = this.clamp(index, 0, Math.max(0, this.cards.length - 1));
        if (this.activeIndex === nextIndex) return;
        this.activeIndex = nextIndex;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === nextIndex;
          card.classList.toggle('is-active', active);
          if (active) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('ndev-v50-lightweight-scenes', NdevV50LightweightScenes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-other-selling-points"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-other-selling-points')) {
    class NdevV50OtherSellingPoints extends BaseElement {
      init() {
        if (this.initialized) this.dispose();
        this.initialized = true;
        this.track = this.querySelector('.ndev-v50-other-selling-points__track');
        this.viewport = this.querySelector('.ndev-v50-other-selling-points__viewport');
        this.rail = this.querySelector('.ndev-v50-other-selling-points__rail');
        this.cards = Array.from(this.querySelectorAll('.ndev-v50-other-selling-point'));
        this.segments = Array.from(this.querySelectorAll('.ndev-v50-other-selling-points__progress-segment'));
        this.images = Array.from(this.querySelectorAll('.ndev-v50-other-selling-point img'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.modeFrame = 0;
        this.isNear = false;
        this.isListening = false;
        this.animationEnabled = false;
        this.inObserverRange = false;
        this.measureDirty = true;
        this.maxDesktopTravel = 0;
        this.activeIndex = -1;
        this.lastLinearProgress = 0;
        this.prewarmHandle = 0;
        this.prewarmUsesIdleCallback = false;
        this.pendingPrewarmIndex = -1;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);
        this.onMediaLoad = this.handleMediaLoad.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.onVisibilityChange = this.handleVisibilityChange.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);
        this.images.forEach((image) => image.addEventListener('load', this.onMediaLoad, { passive: true }));

        if (!this.cards.length) return;

        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this._mq.matches && !this.animationEnabled) return;
            this.measureDirty = true;
            this.scheduleModeSync();
          });
          this.resizeObserver.observe(this.rail);
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inObserverRange = entries.some((entry) => entry.isIntersecting);
            this.setNear(this.inObserverRange);
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.inObserverRange = true;
        }

        this.syncAnimatedMode();
      }

      dispose() {
        if (!this.initialized) return;
        this.setListening(false);
        this.setNear(false);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.cancelPrewarm();
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.images) {
          this.images.forEach((image) => image.removeEventListener('load', this.onMediaLoad));
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.modeFrame) cancelAnimationFrame(this.modeFrame);
        this.frame = 0;
        this.modeFrame = 0;
        this.clearVisualState();
        this.classList.remove('is-ready');
        this.animationEnabled = false;
        this.initialized = false;
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      syncAnimatedMode() {
        const motionAllowed = this.cards.length > 1 && !this.reducedMotion.matches;
        let shouldAnimate = motionAllowed;

        if (motionAllowed && this._mq.matches) {
          this.classList.add('is-ready');
          this.measureDirty = true;
          this.measure();
          shouldAnimate = this.maxDesktopTravel > 0;
        }

        this.animationEnabled = shouldAnimate;
        this.classList.toggle('is-ready', shouldAnimate);

        if (!shouldAnimate) {
          this.setListening(false);
          this.clearVisualState();
          return;
        }

        this.measureDirty = true;
        this.setNear(this.inObserverRange);
      }

      setNear(near) {
        this.isNear = near;
        if (near) this.prewarmAround(Math.max(0, this.activeIndex));
        else this.cancelPrewarm();
        this.setListening(near && this.animationEnabled);
        if (near) this.requestUpdate();
      }

      setListening(listen) {
        if (this.isListening === listen) return;
        this.isListening = listen;

        if (listen) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }

      handleResize() {
        this.measureDirty = true;
        this.scheduleModeSync();
      }

      handleMediaLoad() {
        this.measureDirty = true;
        this.scheduleModeSync();
      }

      handleModeChange() {
        this.measureDirty = true;
        this.syncAnimatedMode();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.cancelPrewarm();
          return;
        }
        if (this.isNear) this.prewarmAround(Math.max(0, this.activeIndex));
      }

      handleBlockSelect(event) {
        if (!this.animationEnabled || !(event.target instanceof Element)) return;
        const selectedCard = event.target.closest('.ndev-v50-other-selling-point');
        if (!selectedCard || !this.contains(selectedCard)) return;

        const cardIndex = this.cards.indexOf(selectedCard);
        const maxIndex = this.cards.length - 1;
        if (cardIndex < 0 || maxIndex < 1) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = Number.parseFloat(getComputedStyle(this.viewport).top) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const targetProgress = cardIndex / maxIndex;
        const trackTop = window.scrollY + trackRect.top;

        window.scrollTo({
          top: trackTop - reservedTop + scrollDistance * targetProgress,
          behavior: 'auto',
        });
        this.requestUpdate();
      }

      scheduleModeSync() {
        if (this.modeFrame) return;
        this.modeFrame = requestAnimationFrame(() => {
          this.modeFrame = 0;
          this.syncAnimatedMode();
        });
      }

      requestUpdate() {
        if (this.frame || !this.classList.contains('is-ready')) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || !this.rail || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const windowHeight = window.innerHeight || 1;
        if (trackRect.bottom < -windowHeight || trackRect.top > windowHeight * 2) return;

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = Number.parseFloat(getComputedStyle(this.viewport).top) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const linearProgress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);
        this.lastLinearProgress = linearProgress;

        if (this.measureDirty) this.measure();

        if (this._mq.matches) {
          this.applyDesktopProgress(linearProgress);
          this.setActiveIndex(Math.round(linearProgress * (this.cards.length - 1)));
        } else {
          const sceneProgress = this.getMobileSceneProgress(linearProgress);
          this.applyMobileProgress(sceneProgress);
          this.setActiveIndex(Math.round(sceneProgress));
        }
      }

      measure() {
        const viewportWidth = this.viewport.getBoundingClientRect().width || window.innerWidth || 1;
        this.maxDesktopTravel = Math.max(0, this.rail.scrollWidth - viewportWidth);
        this.measureDirty = false;
      }

      getMobileSceneProgress(linearProgress) {
        const maxIndex = Math.max(0, this.cards.length - 1);
        const rawStep = linearProgress * maxIndex;
        const stepIndex = Math.min(maxIndex, Math.floor(rawStep));
        if (stepIndex >= maxIndex) return maxIndex;

        const fraction = rawStep - stepIndex;
        const heldFraction = this.clamp((fraction - 0.1) / 0.8, 0, 1);
        const easedFraction = 0.5 - Math.cos(Math.PI * heldFraction) / 2;
        return stepIndex + easedFraction;
      }

      applyDesktopProgress(linearProgress) {
        const offset = -this.maxDesktopTravel * linearProgress;
        this.rail.style.transform = `translate3d(${offset.toFixed(2)}px, 0, 0)`;
      }

      applyMobileProgress(sceneProgress) {
        this.rail.style.transform = '';
        this.cards.forEach((card, index) => {
          const reveal = index === 0 ? 1 : this.clamp(sceneProgress - index + 1, 0, 1);
          const shade = this.clamp(sceneProgress - index, 0, 1) * 0.75;
          card.style.setProperty('--v50-other-selling-points-stack-x', `${((1 - reveal) * 100).toFixed(3)}%`);
          card.style.setProperty('--v50-other-selling-points-shade', shade.toFixed(4));
        });
      }

      setActiveIndex(index) {
        const nextIndex = this.clamp(index, 0, Math.max(0, this.cards.length - 1));
        if (this.activeIndex === nextIndex) return;
        this.activeIndex = nextIndex;
        this.segments.forEach((segment, segmentIndex) => {
          segment.classList.toggle('is-active', segmentIndex === nextIndex);
        });
        this.prewarmAround(nextIndex);
      }

      prewarmAround(index) {
        this.pendingPrewarmIndex = index;
        this.cancelPrewarm(false);
        if (!this.canPrewarm()) return;

        const run = () => {
          this.prewarmHandle = 0;
          if (!this.canPrewarm()) return;
          this.warmImages(this.pendingPrewarmIndex);
        };

        if ('requestIdleCallback' in window) {
          this.prewarmUsesIdleCallback = true;
          this.prewarmHandle = window.requestIdleCallback(run, { timeout: 800 });
        } else {
          this.prewarmUsesIdleCallback = false;
          this.prewarmHandle = window.setTimeout(run, 180);
        }
      }

      canPrewarm() {
        if (!this.isNear || document.hidden) return false;
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return true;
        if (connection.saveData) return false;
        return connection.effectiveType !== '2g' && connection.effectiveType !== 'slow-2g';
      }

      cancelPrewarm(clearPending = true) {
        if (this.prewarmHandle) {
          if (this.prewarmUsesIdleCallback && 'cancelIdleCallback' in window) {
            window.cancelIdleCallback(this.prewarmHandle);
          } else {
            window.clearTimeout(this.prewarmHandle);
          }
        }
        this.prewarmHandle = 0;
        if (clearPending) this.pendingPrewarmIndex = -1;
      }

      warmImages(index) {
        const imageSelector = this._mq.matches
          ? 'img.show-pc[loading="lazy"]'
          : 'img.show-mb[loading="lazy"]';
        [index, index + 1].forEach((cardIndex) => {
          const card = this.cards[cardIndex];
          if (!card) return;
          card.querySelectorAll(imageSelector).forEach((image) => {
            image.loading = 'eager';
            image.fetchPriority = 'low';
          });
        });
      }

      clearVisualState() {
        if (this.rail) this.rail.style.transform = '';
        if (this.cards) {
          this.cards.forEach((card) => {
            card.style.removeProperty('--v50-other-selling-points-stack-x');
            card.style.removeProperty('--v50-other-selling-points-shade');
          });
        }
        if (this.segments) {
          this.segments.forEach((segment) => segment.classList.remove('is-active'));
        }
        this.activeIndex = -1;
      }
    }

    customElements.define('ndev-v50-other-selling-points', NdevV50OtherSellingPoints);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-stardust-light"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-stardust-light')) {
    class NdevV50StardustLight extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-stardust-light__track');
        this.viewport = this.querySelector('.ndev-v50-stardust-light__viewport');
        this.intro = this.querySelector('.ndev-v50-stardust-light__intro');
        this.states = Array.from(this.querySelectorAll('.ndev-v50-stardust-light-state'));
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.readyFrame = 0;
        this.state = null;
        this.isNear = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.requestUpdate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this.desktopMedia, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        this.applyProgress(0);
        this.update();
        this.readyFrame = requestAnimationFrame(() => {
          this.readyFrame = requestAnimationFrame(() => {
            this.readyFrame = 0;
            this.classList.add('is-ready');
          });
        });
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.removeMediaListener(this.desktopMedia, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.readyFrame) cancelAnimationFrame(this.readyFrame);
        this.frame = 0;
        this.readyFrame = 0;
        this.state = null;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      lerp(start, end, progress) {
        return start + (end - start) * progress;
      }

      range(progress, start, end) {
        if (end <= start) return Number(progress >= end);
        return this.clamp((progress - start) / (end - start), 0, 1);
      }

      ease(progress) {
        const value = this.clamp(progress, 0, 1);
        return value * value * (3 - 2 * value);
      }

      getReservedTop() {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        return header + navbar;
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.requestUpdate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        this.state = null;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        if (this.reducedMotion.matches) this.applyProgress(0);
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = this.getReservedTop();
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const progress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);

        this.applyProgress(progress);
      }

      applyProgress(progress) {
        if (!this.viewport || !this.intro) return;

        const firstState = this.states[0];
        const secondState = this.states[1];
        const nextState = progress < 0.4 ? 'intro' : progress < 0.7 || !secondState ? 'double' : 'single';
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const introHeight = this.intro.querySelector('.ndev-v50-stardust-light__intro-content')?.offsetHeight || 0;
        const introTop = this.desktopMedia.matches ? 128 : 32;
        const introStartTop = (viewportHeight - introHeight) / 2;
        const introTravel = this.ease(this.range(progress, 0, 0.33));
        const introY = this.lerp(0, introTop - introStartTop, introTravel);
        const introOpacity = nextState === 'intro' ? 1 : 0;
        const mediaStartY = viewportHeight * (this.desktopMedia.matches ? 0.34 : 0.36);
        const firstMediaY = this.lerp(mediaStartY, 0, introTravel) - 10 * this.ease(this.range(progress, 0.33, 0.66));

        this.style.setProperty('--v50-stardust-intro-y', `${introY.toFixed(2)}px`);
        this.style.setProperty('--v50-stardust-intro-opacity', introOpacity.toFixed(4));
        this.setState(nextState);

        if (firstState) {
          const firstContent = nextState === 'intro' ? 0 : 1;
          firstState.style.setProperty('--v50-stardust-state-background-opacity', String(firstContent));
          firstState.style.setProperty('--v50-stardust-state-media-opacity', '1');
          firstState.style.setProperty('--v50-stardust-state-media-y', `${firstMediaY.toFixed(2)}px`);
          firstState.style.setProperty('--v50-stardust-state-content-opacity', String(firstContent));
          firstState.style.setProperty('--v50-stardust-state-content-y', firstContent ? '0px' : '16px');
          firstState.style.setProperty(
            '--v50-stardust-state-content-pointer-events',
            nextState === 'double' && firstContent > 0.01 ? 'auto' : 'none'
          );
        }

        if (secondState) {
          secondState.style.setProperty('--v50-stardust-state-background-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-media-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-media-y', '0px');
          secondState.style.setProperty('--v50-stardust-state-content-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-content-y', '0px');
          secondState.style.setProperty('--v50-stardust-state-content-pointer-events', nextState === 'single' ? 'auto' : 'none');
        }
      }

      setState(nextState) {
        const resolvedState = this.reducedMotion.matches ? 'static' : nextState;
        if (this.state === resolvedState) return;
        this.state = resolvedState;
        this.setAttribute('state', resolvedState);

        if (this.reducedMotion.matches) {
          this.intro.setAttribute('aria-hidden', 'false');
          this.states.forEach((state) => state.setAttribute('aria-hidden', 'false'));
          return;
        }

        this.intro.setAttribute('aria-hidden', nextState === 'intro' ? 'false' : 'true');
        this.states.forEach((state, index) => {
          const isActive = (nextState === 'double' && index === 0) || (nextState === 'single' && index === 1);
          state.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }
    }

    customElements.define('ndev-v50-stardust-light', NdevV50StardustLight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-triple-anti-tangle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-triple-anti-tangle')) {
    class NdevV50TripleAntiTangle extends BaseElement {
      init() {
        this.items = Array.from(this.querySelectorAll('[data-v50-triple-item]'));
        this.controls = Array.from(this.querySelectorAll('[data-v50-comparison-nav]'));
        this.autoplay = this.getAttribute('autoplay') === 'true';
        this.delay = Math.max(1200, Number(this.getAttribute('autoplay-delay')) || 5000);
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.isInView = false;
        this.raf = 0;
        this.startTime = 0;
        this.observer = null;
        this.onControlClick = this.onControlClick.bind(this);
        this.onIntersection = this.onIntersection.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.tick = this.tick.bind(this);

        this.controls.forEach((control) => {
          control.addEventListener('click', this.onControlClick);
        });
        this.items.forEach((item) => {
          const control = item.querySelector('.v50-comparison-pc-control');
          const panel = item.querySelector('.ndev-v50-triple-anti-tangle-item__panel');
          if (control && panel) control.setAttribute('aria-controls', panel.id);
        });
        this.desktopMedia.addEventListener('change', this.onLayoutChange);
        this.activate(0, { restartAutoplay: false });
        this.setupPlayback();
        this.classList.add('is-ready');
      }

      dispose() {
        this.controls.forEach((control) => control.removeEventListener('click', this.onControlClick));
        this.desktopMedia.removeEventListener('change', this.onLayoutChange);
        this.destroyObserver();
        this.stopAutoplay();
        this.classList.remove('is-ready');
      }

      onControlClick(event) {
        const item = event.currentTarget.closest('[data-v50-triple-item]');
        const index = this.items.indexOf(item);
        if (index >= 0) this.activate(index, { resetProgress: true });
      }

      onIntersection(entries) {
        const entry = entries[0];
        this.isInView = Boolean(entry && entry.isIntersecting);

        if (this.isInView) {
          this.resetProgress();
          this.startAutoplay();
        } else {
          this.resetToDefault();
        }
      }

      onLayoutChange() {
        if (this.desktopMedia.matches && this.isInView) {
          this.resetProgress();
          this.startAutoplay();
        } else {
          this.resetToDefault();
        }
      }

      setupPlayback() {
        if (!this.autoplay) return;

        if (!('IntersectionObserver' in window)) {
          this.isInView = true;
          this.startAutoplay();
          return;
        }

        this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0.35 });
        this.observer.observe(this);
      }

      destroyObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }

      activate(index, options) {
        if (!this.items.length) return;
        const config = options || {};
        this.activeIndex = Math.min(Math.max(index, 0), this.items.length - 1);

        this.items.forEach((item, itemIndex) => {
          const active = itemIndex === this.activeIndex;
          item.classList.toggle('is-active', active);

          const control = item.querySelector('.v50-comparison-pc-control');
          if (control) control.setAttribute('aria-expanded', active ? 'true' : 'false');

          const ring = item.querySelector('[data-v50-comparison-progress-ring="desktop"]');
          if (ring) ring.style.strokeDashoffset = '1';
        });

        if (config.resetProgress !== false) {
          this.resetProgress();
          if (config.restartAutoplay !== false) this.startAutoplay();
        }
      }

      resetToDefault() {
        this.stopAutoplay();
        this.activate(0, { resetProgress: true, restartAutoplay: false });
      }

      resetProgress() {
        this.startTime = performance.now();
        this.writeProgress(0);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canPlay()) return;
        this.raf = requestAnimationFrame(this.tick);
      }

      canPlay() {
        return (
          this.autoplay &&
          this.desktopMedia.matches &&
          !this.reducedMotion.matches &&
          this.items.length > 1 &&
          this.isInView
        );
      }

      stopAutoplay() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      tick(now) {
        if (!this.canPlay()) {
          this.stopAutoplay();
          return;
        }
        if (!this.startTime) this.startTime = now;

        const progress = Math.min((now - this.startTime) / this.delay, 1);
        this.writeProgress(progress);

        if (progress >= 1) {
          const nextIndex = (this.activeIndex + 1) % this.items.length;
          this.activate(nextIndex, { resetProgress: true });
          return;
        }

        this.raf = requestAnimationFrame(this.tick);
      }

      writeProgress(progress) {
        const activeItem = this.items[this.activeIndex];
        const ring = activeItem
          ? activeItem.querySelector('[data-v50-comparison-progress-ring="desktop"]')
          : null;
        if (ring) ring.style.strokeDashoffset = String(1 - Math.min(Math.max(progress, 0), 1));
      }
    }

    customElements.define('ndev-v50-triple-anti-tangle', NdevV50TripleAntiTangle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-x30-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-x30-sale';
    const ROOT_SELECTOR = '[data-ndev-x30-sale]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 初始化逻辑（建议事件绑定都挂在 root 上，并在 destroy 里移除）

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'page-banner';
    const ROOT_SELECTOR = '[data-page-banner]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      const swiperEl = root.querySelector('[data-page-banner-swiper]');
      if (!swiperEl || typeof window.Swiper === 'undefined') return;

      const configEl = root.querySelector('[data-page-banner-config]');
      let config = {};
      if (configEl && configEl.textContent) {
        try { config = JSON.parse(configEl.textContent); } catch (e) {}
      }

      // 注意：Swiper 初始化时可能会触发 slideChange（会调用 updateVerticalTabs/updateHorizontalTabs）
      // 因此这些变量必须在 new Swiper() 之前完成初始化，避免 TDZ 报错导致整个初始化中断。
      const verticalTabsContainer = root.querySelector('[data-page-banner-vertical-tabs]');
      const horizontalTabsContainer = root.querySelector('[data-page-banner-horizontal-tabs]');
      const horizontalTabsPcContainer = root.querySelector('[data-page-banner-horizontal-tabs-pc]');
      const itemHeight = 19.2;

      // 兼容两种 DOM 形态：
      // - Theme Editor: `.swiper-wrapper > .shopify-block > .swiper-slide.page-banner__slide`
      // - Storefront/Preview: `.swiper-wrapper > .swiper-slide.page-banner__slide`
      const slideWrappers = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block'));
      const hasShopifyBlockWrapper = slideWrappers.length > 0;
      const slideEls = hasShopifyBlockWrapper
        ? slideWrappers
        : Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .page-banner__slide'));

      const slideCount = slideEls.length;
      const enableLoop = slideCount > 1;
      const duration = (Number(config.duration) || 5) * 1000;
      const enableAutoplay = config.autoplay !== false;
      const showPagination = config.showPagination !== false;
      const paginationVariant = (config.paginationVariant || root.getAttribute('data-page-banner-pagination-variant') || 'tabs');
      const useCustomTabs = (paginationVariant === 'tabs' || paginationVariant === 'tabs_pc_horizontal');

      const listeners = [];
      let resizeTimeout = null;
      let progressInterval = null;
      let currentProgress = 0;
      let bannerInView = false;
      let mediaObserver = null;
      const breakpointMedia = window.matchMedia('(min-width: 1024px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function on(el, type, handler) {
        if (!el) return;
        el.addEventListener(type, handler);
        listeners.push({ el, type, handler });
      }

      let swiper = null;

      function addMediaChangeListener(media, handler) {
        if (media.addEventListener) media.addEventListener('change', handler);
        else if (media.addListener) media.addListener(handler);
      }

      function removeMediaChangeListener(media, handler) {
        if (media.removeEventListener) media.removeEventListener('change', handler);
        else if (media.removeListener) media.removeListener(handler);
      }

      function pauseBannerVideos() {
        root.querySelectorAll('.page-banner__bg-video').forEach((video) => {
          video.autoplay = false;
          video.preload = 'none';
          video.pause();
        });
      }

      function syncBannerVideos(swiperInstance) {
        const activeSwiper = swiperInstance || swiper;
        const activeSlide = activeSwiper && activeSwiper.slides
          ? activeSwiper.slides[activeSwiper.activeIndex]
          : root.querySelector('.swiper-slide-active');
        const videoSelector = breakpointMedia.matches
          ? '.page-banner__bg-video--desktop'
          : '.page-banner__bg-video--mobile';
        const activeVideo = activeSlide ? activeSlide.querySelector(videoSelector) : null;

        root.querySelectorAll('.page-banner__bg-video').forEach((video) => {
          video.autoplay = false;
          video.preload = 'none';
          if (video !== activeVideo) video.pause();
        });

        if (!activeVideo || !bannerInView || document.hidden || reducedMotion.matches) {
          if (activeVideo) activeVideo.pause();
          return;
        }

        activeVideo.muted = true;
        activeVideo.playsInline = true;
        try {
          const playPromise = activeVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        } catch (error) {
          activeVideo.pause();
        }
      }

      const swiperOptions = {
        loop: enableLoop,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: enableLoop,
        allowTouchMove: enableLoop,
        autoplay: enableAutoplay ? { delay: duration, disableOnInteraction: false } : false,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        on: {
          slideChange: function () {
            syncBannerVideos(this);
            if (showPagination && useCustomTabs) {
              updateVerticalTabs(this.realIndex);
              updateHorizontalTabs(this.realIndex);
              updateHorizontalTabsPc(this.realIndex);
              resetProgress(this);
            }
          }
        }
      };

      if (hasShopifyBlockWrapper) {
        swiperOptions.slideClass = 'shopify-block';
      } else {
        swiperOptions.slideClass = 'page-banner__slide';
      }

      swiper = new Swiper(swiperEl, swiperOptions);
      pauseBannerVideos();
      const onMediaEnvironmentChange = () => syncBannerVideos();
      if ('IntersectionObserver' in window) {
        mediaObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          bannerInView = Boolean(entry && entry.isIntersecting);
          syncBannerVideos();
        });
        mediaObserver.observe(root);
      } else {
        const updateFallbackVisibility = () => {
          const rect = root.getBoundingClientRect();
          bannerInView = rect.bottom > 0 && rect.top < window.innerHeight;
          syncBannerVideos();
        };
        on(window, 'scroll', updateFallbackVisibility);
        on(window, 'resize', updateFallbackVisibility);
        updateFallbackVisibility();
      }
      on(document, 'visibilitychange', onMediaEnvironmentChange);
      addMediaChangeListener(breakpointMedia, onMediaEnvironmentChange);
      addMediaChangeListener(reducedMotion, onMediaEnvironmentChange);
      syncBannerVideos();

      function buildTabs() {
        if (verticalTabsContainer) verticalTabsContainer.innerHTML = '';
        if (horizontalTabsContainer) horizontalTabsContainer.innerHTML = '';
        if (horizontalTabsPcContainer) horizontalTabsPcContainer.innerHTML = '';

        if (!showPagination || slideCount <= 1 || !useCustomTabs) {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
          return;
        }

        if (verticalTabsContainer) {
          verticalTabsContainer.style.removeProperty('display');
          verticalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsContainer) {
          horizontalTabsContainer.style.removeProperty('display');
          horizontalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsPcContainer) {
          horizontalTabsPcContainer.style.removeProperty('display');
          horizontalTabsPcContainer.style.setProperty('--count', slideCount);
        }

        slideEls.forEach((holder, index) => {
          const slide = (holder && holder.classList && holder.classList.contains('page-banner__slide'))
            ? holder
            : (holder ? holder.querySelector('.page-banner__slide') : null);
          const title = (slide && slide.getAttribute && slide.getAttribute('data-tab-title')) || ('Slide ' + (index + 1));
          if (verticalTabsContainer && paginationVariant === 'tabs') {
            const vTab = document.createElement('div');
            vTab.className = 'page-banner__vertical-tab' + (index === 0 ? ' page-banner__vertical-tab--active' : '');
            vTab.textContent = title;
            verticalTabsContainer.appendChild(vTab);
          }

          if (horizontalTabsPcContainer && paginationVariant === 'tabs_pc_horizontal') {
            const pcTab = document.createElement('div');
            pcTab.className = 'page-banner__horizontal-tab-pc' + (index === 0 ? ' page-banner__horizontal-tab-pc--active' : '');
            if (title) {
              const span = document.createElement('span');
              span.className = 'page-banner__horizontal-tab-pc-title';
              span.textContent = title;
              pcTab.appendChild(span);
            }
            horizontalTabsPcContainer.appendChild(pcTab);
          }

          if (horizontalTabsContainer) {
            const hTab = document.createElement('div');
            hTab.className = 'page-banner__horizontal-tab' + (index === 0 ? ' page-banner__horizontal-tab--active' : '');
            horizontalTabsContainer.appendChild(hTab);
          }
        });
      }

      function startProgress() {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        const updateInterval = 50;
        const progressStep = (100 / (duration / updateInterval));
        progressInterval = setInterval(() => {
          currentProgress += progressStep;
          if (currentProgress >= 100) {
            currentProgress = 100;
            clearInterval(progressInterval);
          }
          if (verticalTabsContainer) {
            const heightInPixels = (currentProgress / 100) * itemHeight;
            verticalTabsContainer.style.setProperty('--actived-item-height', heightInPixels + 'px');
          }
          if (activeHorizontalTab) {
            activeHorizontalTab.style.setProperty('--progress-width', currentProgress + '%');
          }
          if (activeHorizontalTabPc) {
            activeHorizontalTabPc.style.setProperty('--progress-width', currentProgress + '%');
          }
        }, updateInterval);
      }

      function stopProgress() {
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
      }

      function resetProgress(swiperInstance) {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        if (verticalTabsContainer) {
          verticalTabsContainer.style.setProperty('--actived-item-height', '0px');
        }
        if (activeHorizontalTab) {
          activeHorizontalTab.style.setProperty('--progress-width', '0%');
        }
        if (activeHorizontalTabPc) {
          activeHorizontalTabPc.style.setProperty('--progress-width', '0%');
        }
        const s = swiperInstance || swiper;
        if (enableAutoplay && s && s.autoplay && s.autoplay.running) {
          setTimeout(() => startProgress(), 100);
        }
      }

      function updateVerticalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__vertical-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__vertical-tab--active');
          else tab.classList.remove('page-banner__vertical-tab--active');
        });
        if (verticalTabsContainer && tabs.length > 0) {
          const itemGap = 18;
          const topPosition = realIndex * (itemHeight + itemGap);
          verticalTabsContainer.style.setProperty('--top', topPosition + 'px');
        }
      }

      function updateHorizontalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab--active');
          else tab.classList.remove('page-banner__horizontal-tab--active');
        });
      }

      function updateHorizontalTabsPc(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab-pc--active');
          else tab.classList.remove('page-banner__horizontal-tab-pc--active');
        });
      }

      function initTabs() {
        const vTabs = root.querySelectorAll('.page-banner__vertical-tab');
        const hTabs = root.querySelectorAll('.page-banner__horizontal-tab');
        const hPcTabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        vTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hPcTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
      }

      function initButtonActions() {
        const buttons = root.querySelectorAll('.page-banner__btn');
        buttons.forEach(button => {
          on(button, 'click', function (e) {
            const actionType = this.getAttribute('data-action-type');
            if (actionType === 'scroll') {
              e.preventDefault();
              const sectionIndex = parseInt(this.getAttribute('data-scroll-to-section'), 10) || 1;
              const sections = Array.from(document.querySelectorAll('#main-content .shopify-section') || []);
              const targetSection = sections[sectionIndex - 1];
              if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } else if (actionType === 'spin') {
              e.preventDefault();
              var spinLink = this.getAttribute('data-spin-link');
              if (spinLink) {
                location.href = spinLink;
                return;
              }
              var spinTrigger = document.getElementById('crazyrocket-launch-icon');
              if (spinTrigger) {
                spinTrigger.click();
              }
            }
          });
        });
      }

      function isInteractiveTarget(target) {
        if (!target || !target.closest) return false;
        return Boolean(
          target.closest(
            'a, button, input, textarea, select, option, label, summary, [role="button"], [data-page-banner-no-slide-link]'
          )
        );
      }

      function navigateBySlide(slide) {
        if (!slide) return;
        const href = slide.getAttribute('data-slide-href');
        if (!href) return;
        const target = slide.getAttribute('data-slide-target');
        if (target === '_blank') window.open(href, '_blank');
        else window.location.href = href;
      }

      function initSlideLinkActions() {
        // 用事件委托覆盖 loop 下的克隆 slide（clone 节点不会继承监听器）
        on(swiperEl, 'click', function (e) {
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const slide = e && e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          navigateBySlide(slide);
        });

        on(swiperEl, 'keydown', function (e) {
          if (!e) return;
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const key = e.key || e.code;
          if (!(key === 'Enter' || key === ' ' || key === 'Spacebar')) return;
          const slide = e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          e.preventDefault();
          navigateBySlide(slide);
        });
      }

      if (swiper) {
        buildTabs();
        initTabs();
        initButtonActions();
        initSlideLinkActions();
        if (showPagination && useCustomTabs) {
          updateVerticalTabs(0);
          updateHorizontalTabs(0);
          updateHorizontalTabsPc(0);
          if (enableAutoplay && swiper.autoplay && swiper.autoplay.running) {
            setTimeout(() => startProgress(), 100);
          }
        } else {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
        }
        on(window, 'resize', function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (swiper && swiper.update) swiper.update();
            syncBannerVideos();
          }, 250);
        });
      }

      root.setAttribute(INIT_ATTR, '1');
      controllers.set(root, {
        root: root,
        destroy: function () {
          listeners.forEach(item => item.el.removeEventListener(item.type, item.handler));
          if (resizeTimeout) clearTimeout(resizeTimeout);
          stopProgress();
          if (mediaObserver) mediaObserver.disconnect();
          removeMediaChangeListener(breakpointMedia, onMediaEnvironmentChange);
          removeMediaChangeListener(reducedMotion, onMediaEnvironmentChange);
          pauseBannerVideos();
          if (swiper && swiper.destroy) swiper.destroy(true, true);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page1"]) return;
  try {
    
  (function() {
      let hydro = { install: 'yes', list: [] };
      let lastTar = null;
      const btn = document.getElementById('page1-next');
      const events = Array.prototype.slice.apply(document.getElementById('page1-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item; 
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          if (index === 2) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/bathroom';
          } else if (index === 4) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/balcony';
          } else {
              hydro.list[0] = { result: 'yes' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/hydroease-question2';
          }
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page2"]) return;
  try {
    
  (function() {
      let hydro = window.sessionStorage.getItem('__hydro__');
      try {
          hydro = JSON.parse(hydro);
      } catch (e) {
          hydro = { install: 'no' };
      }
      document.getElementById('page2-no').addEventListener('click', function() {
          hydro.install = 'no';
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

      document.getElementById('page2-yes').addEventListener('click', function() {
          if (hydro.install === 'yes') {
              hydro.list[1] = { result: 'yes' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page3"]) return;
  try {
    
(function() {
    let lastTar = null;
    const btn = document.getElementById('page3-next');
    const events = Array.prototype.slice.apply(document.getElementById('page3-room').querySelectorAll('.item'));
    events.forEach(item => {
        item.addEventListener('click', function() {
            if (lastTar !== null) {
                lastTar.classList.remove('selected');
            } 

            lastTar = item;
            item.classList.add('selected');
            btn.style.display = 'block';
        });
    });

    btn.addEventListener('click', function() {
        const index = Number(lastTar.dataset.index);
        let hydro = window.sessionStorage.getItem('__hydro__');
        try {
            hydro = JSON.parse(hydro);
            if (index === 1) {
                hydro.intall = 'no';
            } else {
                hydro.list[2] = { result: 'yes' };
            }
        } catch (e) {
            hydro = { install: 'no' };
        }
        window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
        location.href = '/pages/hydroease-question4';
    });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page4"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page4-next');
      const events = Array.prototype.slice.apply(document.getElementById('page4-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[3] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question5';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page5"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page5-next');
      const events = Array.prototype.slice.apply(document.getElementById('page5-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[4] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question6';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page6"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page6-next');
      const events = Array.prototype.slice.apply(document.getElementById('page6-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) { 
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[5] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question7';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page7"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page7-next');
      const events = Array.prototype.slice.apply(document.getElementById('page7-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          }); 
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          window.sessionStorage.removeItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[6] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }

          if (hydro.install === 'yes') {
              if (hydro.list.filter(r => r && r.result === 'yes').length === 7) {
                  location.href = '/pages/freo-hydroease-product';
                  return false;
              }
          }

          location.href = '/pages/freo-product';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixlee-widget"]) return;
  try {
    
  (function(){
    window.PixleeAsyncInit = function() { //2
        Pixlee.init({ apiKey: "t8hC3pFQ7Vc2z2RTMZrm" });
        Pixlee.addCategoryWidget({ widgetId: "7876231", containerId: 'pixlee-widget-box' });
        Pixlee.resizeWidget();
    };
    var pix = document.createElement('script');
    pix.src = '//assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(pix, s);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-buy-box')) {
    class ProductBuyBox extends BaseElement {
      init() {
        if (this.getAttribute('hidden-product') === 'true') {
          window.location.href = this.getAttribute('redirect-url') || '/';
          return;
        }

        const variantIdAttr = this.getAttribute('data-ndev-product-variant-id');
        this._variantId = variantIdAttr ? parseInt(variantIdAttr) : null;
        this._variantPrice = 0;
        this._compareAtPrice = 0;
        this._available = this.getAttribute('data-ndev-product-variant-available') !== 'false';
        this._sources = {};

        const priceAttr = this.getAttribute('data-ndev-product-variant-price');
        if (priceAttr != null) this._variantPrice = parseInt(priceAttr) || 0;

        const titleEl = this.querySelector('.product-buy-box__title');
        this._productTitle = titleEl ? titleEl.textContent.trim() : '';
        this._mobileBlocksEl = this.querySelector('.product-buy-box__blocks');
        this._galleryExtraEl = this.querySelector('[data-pbb-gallery-extra]');
        this._featureListEl = this.querySelector('.product-buy-box-block--feature-list');
        this._desktopFeatureNextSibling = this._featureListEl ? this._featureListEl.nextSibling : null;
        this._desktopFeatureParent = this._featureListEl ? this._featureListEl.parentNode : null;
        this._stickyZoneEl = this.querySelector('[data-product-buy-box-sticky-zone]');
        this._siteHeaderEl = document.querySelector('#site-header');

        this._onVariantChange = (e) => {
          const d = e.detail || {};
          if (d.variantId) {
            this._variantId = d.variantId;
            this.setAttribute('data-ndev-product-variant-id', String(d.variantId));
          }
          if (d.price != null) {
            this._variantPrice = d.price;
            this.setAttribute('data-ndev-product-variant-price', String(d.price));
          }
          if (d.compareAtPrice != null) this._compareAtPrice = d.compareAtPrice;
          if (d.available != null) this._available = d.available;
          this._dispatchTotalUpdate();
        };

        this._onSourceChange = (e) => {
          const d = e.detail || {};
          const src = d.source;
          if (!src) return;
          if (d.total == null) {
            delete this._sources[src];
          } else {
            this._sources[src] = { total: d.total, items: d.items || [] };
          }
          this._dispatchTotalUpdate();
        };

        this._onMediaChange = () => this._placeResponsiveBlocks();
        this._onStickyNavVisibilityChange = (e) => this._syncStickyDisplay(e.detail || {});

        this.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.addEventListener('product-buy-box:source-change', this._onSourceChange);
        this.addEventListener('ndev-sticky-anchor-navbar:visibility-change', this._onStickyNavVisibilityChange);

        this._mediaQuery = window.matchMedia('(max-width: 1023px)');
        this._mediaQuery.addEventListener('change', this._onMediaChange);
        this._syncStickyDisplay({ visible: false });
        this._placeResponsiveBlocks();
        this._dispatchTotalUpdate();
      }

      dispose() {
        this.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.removeEventListener('product-buy-box:source-change', this._onSourceChange);
        this.removeEventListener('ndev-sticky-anchor-navbar:visibility-change', this._onStickyNavVisibilityChange);
        this._setHeaderHidden(false);
        this._mediaQuery?.removeEventListener('change', this._onMediaChange);
      }

      _syncStickyDisplay(detail) {
        const mode = this._stickyZoneEl?.getAttribute('data-display-mode') || 'replace_header';
        const replacing = mode === 'replace_header' && Boolean(detail.visible);
        this.classList.toggle('is-sticky-replacing-header', replacing);
        this._setHeaderHidden(replacing);
      }

      _setHeaderHidden(hidden) {
        if (!this._siteHeaderEl) return;
        this._siteHeaderEl.classList.toggle('is-hidden', hidden);
      }

      _computeSourcesTotal() {
        let t = 0;
        for (const s in this._sources) {
          t += this._sources[s].total;
        }
        return t;
      }

      _dispatchTotalUpdate() {
        const sourcesTotal = this._computeSourcesTotal();
        const totalPrice = this._variantPrice + sourcesTotal;

        this.dispatchEvent(
          new CustomEvent('product-buy-box:total-update', {
            bubbles: true,
            composed: true,
            detail: {
              variantId: this._variantId,
              variantPrice: this._variantPrice,
              compareAtPrice: this._compareAtPrice,
              available: this._available,
              sources: Object.assign({}, this._sources),
              sourcesTotal,
              totalPrice,
            },
          })
        );
      }

      _placeResponsiveBlocks() {
        if (!this._featureListEl || !this._mobileBlocksEl || !this._desktopFeatureParent) return;

        if (this._mediaQuery.matches) {
          if (this._featureListEl.parentNode !== this._mobileBlocksEl) {
            this._mobileBlocksEl.appendChild(this._featureListEl);
          }
        } else if (this._featureListEl.parentNode !== this._desktopFeatureParent) {
          if (
            this._desktopFeatureNextSibling &&
            this._desktopFeatureNextSibling.parentNode === this._desktopFeatureParent
          ) {
            this._desktopFeatureParent.insertBefore(this._featureListEl, this._desktopFeatureNextSibling);
          } else {
            this._desktopFeatureParent.appendChild(this._featureListEl);
          }
        }
      }

      getCartItems() {
        const nonce = Date.now() + Math.floor(Math.random() * 100000);
        const sourceItems = [];
        for (const s in this._sources) {
          const items = this._sources[s].items || [];
          for (let i = 0; i < items.length; i++) {
            sourceItems.push(items[i]);
          }
        }

        if (!sourceItems.length) {
          return [{ varId: this._variantId, qty: 1 }];
        }

        const result = [];
        for (let j = 0; j < sourceItems.length; j++) {
          const item = sourceItems[j];
          result.push({
            varId: item.variantId,
            qty: item.quantity || 1,
            properties: Object.assign({}, item.properties || {}, {
              _group_id: nonce,
              _group_parent: false,
              For: this._productTitle,
            }),
          });
        }
        result.push({
          varId: this._variantId,
          qty: 1,
          properties: {
            _group_id: nonce,
            _group_parent: true,
          },
        });
        return result;
      }
    }
    customElements.define('product-buy-box', ProductBuyBox);
  }

  } catch(e) { console.error(e); }
})();
})();
